import { React, useEffect, useState, useRef } from "react";
import {
  Button,
  Form,
  Input,
  Select,
  Col,
  Row,
  Checkbox,
  Radio,
  AutoComplete,
  Tooltip,
  Dropdown,
  Menu
} from "antd";
import { Collapse } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import {
  HaberForm,
  RightDrawerContainer,
  DownArrowDraw,
  DetailFields,
  DropDownSearchDraw,
} from "../../styledElements";
import RightDrawerSidebar from "../../../Components/RightDrawer/rightDrawer";
import { DisabledButtonStyle, Styled, StyledTab } from "../../pageStyled";
import { DatePicker } from "antd";
import {
  DatePickerY,
  GlobalSet,
  DisabledStyles,
  DeliveryaddressSpacing,
} from "../../pageStyled";
import {
  addPo,
  postOrder,
  getPackagingList,
  restoreOrder,
} from "../../../Services/orderServices";
import { Country, State } from "country-state-city";
import moment from "moment";
import {
  getProductDetails,
  getProductsData,
  getProducts
} from "../../../Services/productServices";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import { BackTop } from "antd";
import {
  getMachineGradeSelect,
  getReelCoreValues,
} from "../../../Services/settingsServices";
import { getCustomerDetails } from "../../../Services/customerServices";
import { getMachineGradeSelectForConfig } from "../../../Services/settingsServices";
import Multiselect from "multiselect-react-dropdown";
import styled from "styled-components";
import {
  lengthUnit,
  weightUnit,
  weight_Unit_Conversions,
  orderDim_Rewinder_Unit_Conversion,
  currency_List,
  conversionFactorTonneToUnits,
  CoversionFactorCMToUnits,
  conversionFactorUnitsToTonne
} from "../../../Utils/Constant/MeasurementUnitList";
import { getUnitData } from "../../../Services/measurementService";
import {
  PaperMachineQualitySelect,
  PaperMachineGradeSelect,
} from "../../pageStyled";
import {
  getAllOrdersListByOrderno,
  getPosDetails,
  rejectOrApproveOrder,
  updateOrder,
  deleteOrder,
  updateIncompleteOrder,
  changeOrderPriority,
  bulkChangeOrderState,
  getAllDeckleMatchingOrdersListByOrderno,
} from "../../../Services/orderServices";
import { getWorkflowSettings } from "../../../Services/workFlowSettingsServices";
import alertBlue from "../../../Assets/Icons/alertBlue.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import alertYellow from "../../../Assets/Icons/alertYellow.svg";
import warning from "../../../Assets/Icons/warning.png";
import { ModalPopup } from "../../../Components/Modal/modal";
import { useLocation, useNavigate } from "react-router-dom";
import ConfirmationModal from "../../../Components/Modal/ConfirmationModal";

const multiselectStyle = {
  chips: {},
  searchBox: {
    border: "2px solid #dfe1e6",
    "border-radius": "8px",
    width: "332px",
    "background-color": "var(--form-element-bg)",
  },
  option: {
    // To change css for dropdown options
    //background : "gray"
  },
};
const capitalize = (item) => item?.charAt(0)?.toUpperCase() + item?.slice(1);

const MultiSelectCard = styled.div`
  .optionContainer li:hover,
  .optionContainer .highlight {
    background: #edebe9;
    color: black;
  }
  .multiSelectContainer input[type="text"] {
    padding-left: 15px !important;
    width: 100%;
  }
  .optionContainer .highlight {
    background: white;
    color: black;
  }
  .optionListContainer {
    z-index: 100;
  }
  li.groupHeading {
    color: black;
    padding: 5px 15px;
    pointer-events: none;
    font-weight: 500;
  }
  .multiSelectContainer ul {
    border-radius: 0px;
    margin-top: 4px;
    width: 332px;
  }
  .multiSelectContainer input[type="checkbox"] {
    accent-color: rgb(234, 101, 91);
  }
`;

const { Option } = Select;
const grainTypeData = ["Long Grain", "Short Grain"];
const rewinderType = [
  { label: "Constant", value: "constant" },
  { label: "Range", value: "range" },
];
const plyData = [
  { label: "Single Ply", value: 1 },
  { label: "Double Ply", value: 2 },
  { label: "3-Ply", value: 3 },
  { label: "4-Ply", value: 4 },
];
const stateData = [
  {
    key: "approved",
    value: "Active"
  },
  {
    key: "complete",
    value: "Produced"
  }
];

const allStateData = {
  "open": "Provisional",
  "pending": "Pending Confirmation",
  "review": "Changes Requested",
  "rejected": "Confirmation Rejected",
  "approved": "Active",
  "in_process": "",
  "hold": "On-Hold",
  "cancel": "Cancelled",
  "in_production": "In Production",
  "complete": "Produced"
};

const { TextArea } = Input;
const { Panel } = Collapse;

const MultiDiaEditOrderDrawer = (props) => {
  // console.log('props.selectedOrder',props.selectedOrder);
  
  const [form] = Form.useForm();
  const history = useNavigate();
  const [orderDetails, setOrderDetails] = useState();
  const [details, setDetails] = useState();
  const [orderQuantityTab, setOrderQuantityTab] = useState();
  const [checkedBox, setCheckedBox] = useState(false);
  const [mixedGrain, setMixedGrain] = useState(false);
  const [isMixedGrainEnabled, setMixedGrainEnabled] = useState(false);
  const [grainChanges, setGrainChanges] = useState(false);
  const [orderTypes, setOrderTypes] = useState([]);
  const [products, setProducts] = useState([]);
  const [tolData, setTolData] = useState();
  const [orderQuantity, setOrderQuantity] = useState("weight");
  const [unitPlaceholder, setUnitPlaceholder] = useState("");
  const [balanceUnitPlaceholder, setBalanceUnitPlaceholder] = useState("");
  const [coreOD, setCoreod] = useState("");
  const [reelOD, setReelod] = useState("");
  const [grainValue, setGrain] = useState("");
  const [lengthValue, setLength] = useState("");
  const [widthValue, setWidth] = useState("");
  const [weightValue, setWeight] = useState("");
  const [quantityValue, setQuantity] = useState("");
  const [defaultUpperOrderTol, setDefaultUpperOrderTol] = useState("");
  const [defaultLowerOrderTol, setDefaultLowerOrderTol] = useState("");
  const [orderUpperTol, setOrderUpperTol] = useState("");
  const [orderLowerTol, setOrderLowerTol] = useState("");
  const [dimesionUnitList, setDimesionUnitList] = useState([]);
  const [weightUnitList, setWeightUnitList] = useState([]);
  const [currencyUnitData, setCurrencyUnitData] = useState([]);
  const [orderMangtSettings, setOrderMangtSettings] = useState();
  const [reelCoreData, setReelCoreData] = useState();
  const [reelValues, setReelvalues] = useState();
  const [coreValues, setCoreValues] = useState();
  const [measurementData, setMeasurementData] = useState();
  const [productData, setProductData] = useState();
  const [widthUnit, setWidthUnit] = useState();
  const [dealerPriceValue, setDealerPriceValue] = useState();
  const [selectedType, setSelectedType] = useState();
  const [selectedPly,setSelectedPly]=useState(1);
  const [planningWeightValue, setPlanningWeightValue] = useState("");
  const [planningQuantityValue, setPlanningQuantityValue] = useState("");
  const [isToleranceDisabled, setToleranceDisabled] = useState(false);
  const [netPrice, setNetPrice] = useState("");
  const [netPriceSymbol, setNetPriceSymbol] = useState("");
  const [priceUnit, setPriceUnit] = useState("");
  const [selectedPackaging, setSelectedPackaging] = useState("");
  const [packagingData, setPackagingData] = useState([]);
  const [cities, setCities] = useState([]);
  const [planningWtErr, setPlanningWtErr] = useState(false);
  const [selectedReelOD, setSelectedReelOD] = useState();
  const [reelODValidationError, setReelODValidationError] = useState(false);
  const [coreOdValidationError, setCoreOdValidationError] = useState(false);
  const [rangeValidationError, setRangeValidationError] = useState(false);
  const [plannedReels, setPlannedReels] = useState(0);
  const [plannedWeight, setPlannedWeight] = useState(0);
  const [isFirstLoad, setFirstLoad] = useState(false);
  const [outerDiameter, setOuterDiameter] = useState("constant");
  const [rerender, setRerender] = useState(false);
  const [holdOrders, setHoldOrders] = useState(false);
  const [isVisibleDeleteModal, setIsVisibleDeleteModal] = useState(false);
  const [isVisiblePriorityModal, setIsVisiblePriorityModal] = useState(false);
  const [isVisibleReleaseModal, setIsVisibleReleaseModal] = useState(false);
  const [pendingQuantity, setPendingQuantity] = useState("");
  const [pendingQntWeight, setPendingQntWeight] = useState("");
  const [minReel, setMinReel] = useState("");
  const [maxReel, setMaxReel] = useState("");
  const [rangeUnitValue, setRangeUnitValue] = useState("");
  const [isVisibleApprovalModal, setIsVisibleApprovalModal] = useState({
    visible: false,
    data: {},
  });
  const firstLoadRef = useRef(true);
  const [switchFetchOrdersfromERP,setSwitchFetchOrdersfromERP] = useState(false);
  const [balanceQtyErr, setBalanceQtyErr] = useState(false);

    useEffect(()=>{
      (async()=>{
        const orderManagementSettings = await getWorkflowSettings("order_management");
        setSwitchFetchOrdersfromERP(orderManagementSettings?.data?.fetch_orders_from_erp?.value);
      })();
    },[])

  const handleClose = () => {
    form.resetFields();
    setMixedGrain(false);
        setGrainChanges(false);
        setCoreOdValidationError(false);
        setRerender(false);
        setToleranceDisabled(false);
        setFirstLoad(false);
        setPlanningWtErr(false);
        setGrain("");
        setLength("");
        setWidth("");
        setWeight("");
        setQuantity("");
        setPlanningQuantityValue("");
        setPlanningWeightValue("");
        setSelectedPackaging("");
        setOrderUpperTol("");
        setOrderLowerTol("");
        setProductData();
        setDealerPriceValue();
        setPlannedReels(0);
        setPlannedWeight(0);
        setOrderQuantity("weight");
        setPriceUnit("");
    props.onCloseGrade();
  };

  const onChangeCollpase = (key) => {};

  const onFinish = (e) => {
    e = {
      ...e,
      delivery_date: new Date(e.delivery_date).getFullYear() + "-" + (new Date(e.delivery_date).getMonth() + 1) +
        "-" +
        new Date(e.delivery_date).getDate() +
        "T00:00:00Z",
        delivery_address_line_1: form.getFieldValue("delivery_address_line_1"),
        delivery_address_line_2: form.getFieldValue("delivery_address_line_2"),
        delivery_city: form.getFieldValue("delivery_city"),
        delivery_state: form.getFieldValue("delivery_state"),
        delivery_country: form.getFieldValue("delivery_country"),
        delivery_pincode: form.getFieldValue("zip_code"),
        order_upper_tolerance: form.getFieldValue("order_upper_tolerance"),
        order_lower_tolerance: form.getFieldValue("order_lower_tolerance"),
        planned_weight: form.getFieldValue("planned_weight") ? form.getFieldValue("planned_weight") : plannedWeight,
        no_of_reel_sheet: form.getFieldValue("no_of_reel_sheet"),
        planning_weight: form.getFieldValue("planning_weight") ? form.getFieldValue("planning_weight") : planningWeightValue,
        planning_quantity: form.getFieldValue("planning_quantity") ? form.getFieldValue("planning_quantity") : planningQuantityValue,
        core_OD: form.getFieldValue("core_OD"),
        reel_OD: form.getFieldValue("reel_OD"),        
        minimum_reel_od: form.getFieldValue("minimum_reel_od") ? form.getFieldValue("minimum_reel_od") : minReel,
        maximum_reel_od: form.getFieldValue("maximum_reel_od") ? form.getFieldValue("maximum_reel_od") : maxReel,
        reelOD_unit: form.getFieldValue("reelOD_unit") ? form.getFieldValue("reelOD_unit") : rangeUnitValue
    };

    
    if (!coreOdValidationError && !reelODValidationError && !planningWtErr && !balanceQtyErr) {
      if(props?.type === "orderRecord"){
        if((props?.selectedState === "Open") || (
          // (props?.isEditFromIncompleteOrder && props?.type === "deckleRecord") || 
          (props?.isEditFromIncompleteOrder && !orderMangtSettings?.data?.edit_after_approval?.value && props?.type === "orderRecord"))){
            handleSave(e)
        } else if(e.planning_weight > 0 || e.planning_quantity > 0){
            handleApproval(e);
        }
      } else{
        handleSave(e);
      }
    }
  };

  const handleSave = (event) => {
    editOrder(event).then((res) => {
        setMixedGrain(false);
        setGrainChanges(false);
        setCoreOdValidationError(false);
        setRerender(false);
        setToleranceDisabled(false);
        setFirstLoad(false);
        setPlanningWtErr(false);
        setGrain("");
        setLength("");
        setWidth("");
        setWeight("");
        setQuantity("");
        setPlanningQuantityValue("");
        setPlanningWeightValue("");
        setSelectedPackaging("");
        setOrderUpperTol("");
        setOrderLowerTol("");
        setProductData();
        setDealerPriceValue();
        setPlannedReels(0);
        setPlannedWeight(0);
        setOrderQuantity("weight");
        setPriceUnit("");
        form.setFieldsValue({
          length: "",
          width: "",
          weight: "",
          quantity: "",
          planning_quantity: "",
          planning_weight: "",
          no_of_reel_sheet: "",
          planned_weight: "",
          dealer_price: "",
          customer_price: "",
          packaging_name: "",
          remarks: ""
        });
      props.onClose();

    });
  };

  const editOrder = async (event) => {
    let reelODArr = [];
    let reelod = [];
    let reel_od = [];
    if(selectedReelOD?.length){
      selectedReelOD?.map ((item) => {
        reelODArr.push(item?.value);
      });
    }
    let quantityKey = 0;
    let plannedSheetsValue = 0;
    if(((selectedReelOD && selectedReelOD?.length == 1) || (orderQuantity == "reel" && selectedType == "reel") && outerDiameter == "constant")){
      quantityKey = parseFloat(event?.no_of_reel_sheet);
    }
    if(orderQuantity == "sheet" && selectedType == "sheet"){
        plannedSheetsValue = parseFloat(planningQuantityValue);
    }

    let plannedWeightValue = 0;
    if(((((event.core_OD && selectedReelOD && selectedReelOD?.length == 1) || (!event.core_OD && selectedReelOD && selectedReelOD?.length == 0) ||
    (!event.core_OD && selectedReelOD && selectedReelOD?.length == 1) || (event.core_OD && selectedReelOD && selectedReelOD?.length == 0)) 
    && selectedType?.toLowerCase() == "sheet") ||
    (((event.core_OD && ((selectedReelOD && selectedReelOD?.length == 1) || (event.reel_OD && orderQuantity == "reel"))) ||
    (!event.core_OD && ((selectedReelOD && selectedReelOD?.length == 0) || (!event.reel_OD && orderQuantity == "reel")) && orderQuantity != "weight") || 
    (event.core_OD && ((selectedReelOD && selectedReelOD?.length == 0) || (!event.reel_OD && orderQuantity == "reel")) && orderQuantity != "weight")) 
    && selectedType?.toLowerCase() == "reel")) && outerDiameter == "constant"){
      plannedWeightValue = parseFloat(event?.planned_weight);
    } else if((((selectedReelOD && selectedReelOD?.length > 1) || (event.core_OD)) && orderQuantity == "weight" && outerDiameter == "constant") || (orderQuantity == "weight" && outerDiameter == "range")){
      plannedWeightValue = parseFloat(event?.planning_weight);
    } else if((outerDiameter == "range" && orderQuantity != "weight") || (selectedReelOD && selectedReelOD?.length > 1 && orderQuantity == "sheet" && outerDiameter == "constant")){
      plannedWeightValue = 0;
    }

    let body;
    if(props?.type === "orderRecord"){
      body = {
        type: selectedType?.toLowerCase(),
        length: event.length? parseFloat(event.length) : 0,
        width: event.width? parseFloat(event.width) : 0,
        ...(event.grain && { grain: event.grain?.split(" ")[0].toLowerCase() }),
        delivery_address_line_1: event.delivery_address_line_1,
        delivery_address_line_2: event.delivery_address_line_2,
        delivery_city: event.delivery_city,
        delivery_state: event.delivery_state,
        delivery_country: Country.getCountryByCode(event.delivery_country)
          ? Country.getCountryByCode(event.delivery_country).name
          : event.delivery_country,
        delivery_pincode: event.delivery_pincode,
        net_price: netPrice ? parseFloat(netPrice) : 0,
        dealer_price: event.dealer_price ? parseFloat(event.dealer_price) : 0,
        customer_price: event.customer_price ? parseFloat(event.customer_price) : 0,
        currency: event.currency,
        delivery_date: props.category==='so'?null:event.delivery_date,
        product: event.product_code,
        remarks: event.remarks,
        comments: [],
        quantity: quantityKey,
        quantity_type: orderQuantity === "weight" ? "weight" : "reel_sheet",
        ...(orderQuantity !== "weight" && {
          no_of_reel_sheet: quantityValue ? parseFloat(quantityValue) : 0,
        }),
        ...(orderQuantity === "weight" && { weight: weightValue ? (parseFloat(weightValue)) : (event.weight ? parseFloat(event.weight) : 0) }),
        use_po_address: checkedBox ? true : false,
        ...event.packaging_name && {packaging_details: event.packaging_name ? parseFloat(event.packaging_name) : ""},
        // planned_weight: (((selectedReelOD && selectedReelOD?.length == 1) || (event.type.toLowerCase() == "sheet") || (orderQuantity == "weight" && event.type.toLowerCase() == "reel") ||
        // (event.core_OD && event.reel_OD && event.type.toLowerCase() == "reel" && orderQuantity == "reel")) && outerDiameter == "constant") ?  parseFloat(event?.planned_weight) : (orderQuantity === "weight" ?  parseFloat(event?.planning_weight) : 0),        quantity: quantityKey,
        planned_weight: plannedWeightValue,
        planned_sheets: plannedSheetsValue,
        planning_weight: event.planning_weight ? parseFloat(event.planning_weight) : 0,
        planning_quantity: event.planning_quantity ? parseFloat(event.planning_quantity) : 0,
        id_od_type: outerDiameter,
        inner_dia: event.core_OD,
        ...(orderMangtSettings?.data?.fetch_balance_quantity?.value && { 
          balance_weight: parseFloat(form.getFieldValue("balance_qty")),
          state: (details?.state == "approved" || details?.state == "complete") ? form.getFieldValue("order_status") : details?.state
        }),
        ...(outerDiameter == "constant" && {outer_dia: (selectedType == "reel" && orderQuantity === "reel") ? (event?.reel_OD ? [event.reel_OD] : reel_od) : reelODArr}),
        ...(selectedType === "sheet" && {
        rotation: grainChanges,
        grain_mixing: mixedGrain}),
        ...(selectedType === "reel" && {
          ply: parseFloat(event?.ply)
        }),
        tolerances: {
            ...(orderQuantity === "weight" && { weight: {
              upper_tolerance: parseFloat(event?.order_upper_tolerance),
              lower_tolerance: parseFloat(event?.order_lower_tolerance),
              calculated_upper_tolerance: parseFloat(orderUpperTol),
              calculated_lower_tolerance: parseFloat(orderLowerTol),
              units: unitPlaceholder
            }})
          },
        ...(outerDiameter == "range" && {minimum_reel_od: event.minimum_reel_od ? parseFloat(event.minimum_reel_od) : 0}),
        ...(outerDiameter == "range" && {maximum_reel_od: event.maximum_reel_od ? parseFloat(event.maximum_reel_od) : 0}),
        units: {
          ...orderQuantity === "weight" && {weight: event.weightUnit},
          ...(orderMangtSettings?.data?.fetch_balance_quantity?.value && { balance_weight: event.weightUnit }),
          length: event.dimensionUnit,
          width: event.dimensionUnit,
          planned_weight: unitPlaceholder,
          dealer_price: event.currency,
          net_price: event.currency,
          customer_price: event.currency,
          per_weight_unit: productData?.units?.per_weight_unit,
          ...(outerDiameter == "range" && {minimum_reel_od: event.reelOD_unit}),
          ...(outerDiameter == "range" && {maximum_reel_od: event.reelOD_unit}),
        },
        category: props?.category,

      };
    } else{
      body = {
        type: selectedType?.toLowerCase(),
        length: orderDetails?.length ? parseFloat(orderDetails.length) : 0,
        width: orderDetails?.width ? parseFloat(orderDetails.width) : 0,
        ...(orderQuantity === "weight" && { weight: parseFloat(weightValue) }),
        product: orderDetails?.product,
        ply: orderDetails?.ply,
        quantity_type: orderQuantity === "weight" ? "weight" : "reel_sheet",
        ...(orderQuantity !== "weight" && {
          no_of_reel_sheet: quantityValue ? parseFloat(quantityValue) : 0,
        }),
        // planned_weight: (((selectedReelOD && selectedReelOD?.length == 1) || (event.type.toLowerCase() == "sheet") || (orderQuantity == "weight" && event.type.toLowerCase() == "reel")
        // (event.core_OD && event.reel_OD && event.type.toLowerCase() == "reel" && orderQuantity == "reel")) && outerDiameter == "constant") ?  parseFloat(event?.planned_weight) : (orderQuantity === "weight" ?  parseFloat(event?.planning_weight) : 0),        quantity: quantityKey,
        planned_weight: plannedWeightValue,
        quantity: quantityKey,
        net_price: netPrice ? parseFloat(netPrice) : 0,
        dealer_price: orderDetails?.dealer_price? parseFloat(orderDetails.dealer_price) : 0,
        customer_price: orderDetails?.customer_price ? parseFloat(orderDetails.customer_price) : 0,
        planned_sheets: plannedSheetsValue,
        planning_weight: event.planning_weight ? parseFloat(event.planning_weight) : 0,
        planning_quantity: event.planning_quantity ? parseFloat(event.planning_quantity) : 0,
        id_od_type: outerDiameter,
        inner_dia: event.core_OD,
        ...(orderMangtSettings?.data?.fetch_balance_quantity?.value && { 
          balance_weight: parseFloat(form.getFieldValue("balance_qty")),
          state: form.getFieldValue("order_status")
        }),
        ...(outerDiameter == "constant" && {outer_dia: (selectedType == "reel" && orderQuantity === "reel") ? (event?.reel_OD ? [event.reel_OD] : reel_od) : reelODArr}),
        ...(outerDiameter == "range" && {minimum_reel_od: event.minimum_reel_od ? parseFloat(event.minimum_reel_od) : 0}),
        ...(outerDiameter == "range" && {maximum_reel_od: event.maximum_reel_od ? parseFloat(event.maximum_reel_od) : 0}),
        tolerances: {
          ...(orderQuantity === "weight" && { 
            weight: {
            upper_tolerance: parseFloat(orderDetails?.tolerances.weight.upper_tolerance),
            lower_tolerance: parseFloat(orderDetails?.tolerances.weight.lower_tolerance),
            calculated_upper_tolerance: parseFloat(orderDetails?.tolerances.weight.calculated_upper_tolerance),
            calculated_lower_tolerance: parseFloat(orderDetails?.tolerances.weight.calculated_lower_tolerance),
            units: unitPlaceholder
          }
        })
        },
        units: {
          ...orderDetails?.units,          
          ...(orderMangtSettings?.data?.fetch_balance_quantity?.value && { balance_weight: unitPlaceholder }),
          ...(outerDiameter == "range" && {minimum_reel_od: event.reelOD_unit}),
          ...(outerDiameter == "range" && {maximum_reel_od: event.reelOD_unit}),
        }
      }
    }

    console.log({body: body});
    props.isRestore ? restoreOrder(props?.selectedOrderNo, body, props?.type).then((response) => {
      props?.rendering(true);
      props?.toasterAction({
        error: response.error,
        msg: `Changes are successfully saved to Order ${props?.selectedOrderNo}`,
      });
      props.showToaster();
    })
    .catch((error) => {
        console.log("Error in updating order:", error?.response?.data);
        props.toasterAction({
          error: error.response.error,
          msg: error.response.msg,
        });
        props.showToaster();
    })
        : updateOrder(props?.selectedOrderNo, body, props?.type).then((response) => {
          props?.rendering(true);
          props?.toasterAction({
            error: response.error,
            msg: `Changes are successfully saved to Order ${props?.selectedOrderNo}`,
          });
          props.showToaster();
    })
    .catch((error) => {
        console.log("Error in updating order:", error?.response?.data);
        props.toasterAction({
          error: error.response.error,
          msg: error.response.msg,
        });
        props.showToaster();
    });

  };

  const handleApproval = (event) => {
    setIsVisibleApprovalModal({
      visible: true,
      data: event,
    });
  };

  const approvalModalClose = () => {
    setIsVisibleApprovalModal({
      ...isVisibleApprovalModal,
      visible: false,
    });

  };

  const approvalModalConfirm = (data) => {
    setIsVisibleApprovalModal({
      ...isVisibleApprovalModal,
      visible: false,
    });

    editOrder(data).then((res) => {
      setMixedGrain(false);
      setGrainChanges(false);
      setCoreOdValidationError(false);
      setRerender(false);
      setToleranceDisabled(false);
      setFirstLoad(false);
      setPlanningWtErr(false);
      setGrain("");
      setLength("");
      setWidth("");
      setWeight("");
      setQuantity("");
      setPlanningQuantityValue("");
      setPlanningWeightValue("");
      setSelectedPackaging("");
      setOrderUpperTol("");
      setOrderLowerTol("");
      setProductData();
      setDealerPriceValue();
      setPlannedReels(0);
      setPlannedWeight(0);
      setOrderQuantity("weight");
      setPriceUnit("");
      form.setFieldsValue({
        length: "",
        width: "",
        weight: "",
        quantity: "",
        planning_quantity: "",
        planning_weight: "",
        no_of_reel_sheet: "",
        planned_weight: "",
        dealer_price: "",
        customer_price: "",
        packaging_name: "",
        remarks: ""
      });
      props.onClose();

  });
    
  };
  const handlePlyChange=(e) =>{
    setSelectedPly(e);
    setProductData();
    setProducts([]);
    form.setFieldsValue({
      product_code: ""
    });
  }
  const handleType = async (e) => {
    setSelectedType(e);
    form.setFieldsValue({
      length: "",
      reel_OD: "",
      core_OD: "",
      width: "",
      weight: "",
      quantity: "",
      planning_quantity: "",
      planning_weight: "",
      no_of_reel_sheet: "",
      planned_weight: "",
      dealer_price: "",
      customer_price: "",
      packaging_name: "",
      remarks: "",
      product_code: ""
    });
    // form.resetFields(["width", "length", "packaging_name", "product_code"]);
    setLength("");
    setReelod("");
    setCoreod("");
    setGrain("");
    setWidth("");
    setWeight("");
    setQuantity("");
    setPendingQuantity("");
    setMinReel("");
    setMaxReel("");
    setPendingQntWeight("");
    setPlanningQuantityValue("");
    setPlanningWeightValue("");
    setSelectedPackaging("");
    setOrderUpperTol("");
    setOrderLowerTol("");
    setProductData();
    setDealerPriceValue();
    setPlannedReels(0);
    setPlannedWeight(0);
    setPlanningWtErr(false);
    setReelODValidationError(false);
    setMixedGrain(false);
    setGrainChanges(false);
    setCoreOdValidationError(false);
    setReelODValidationError(false);
    setOrderQuantity("weight");
    setWidthUnit(measurementData.data.units_management.length.default);
    setUnitPlaceholder(measurementData.data.units_management.weight.default);
    setBalanceUnitPlaceholder(measurementData.data.units_management.weight.default);
    form.setFieldsValue({dimesnionUnit: measurementData.data.units_management.length.default});
    form.setFieldsValue({weightUnit: measurementData.data.units_management.weight.default});
    form.setFieldsValue({currency: measurementData.data.units_management.currency.default});
    setSelectedReelOD([]);
    setOrderQuantityTab([
      { label: "Weight", value: "weight" },
      {
        label: `${capitalize(e)}s`,
        value: e,
      },
    ]);
    if(orderQuantity == "weight" && e == orderDetails?.type){
      form.setFieldsValue({order_upper_tolerance: orderDetails?.tolerances?.weight?.upper_tolerance});
      form.setFieldsValue({order_lower_tolerance: orderDetails?.tolerances?.weight?.lower_tolerance});
      setDefaultUpperOrderTol(orderDetails?.tolerances?.weight?.upper_tolerance);
      setDefaultLowerOrderTol(orderDetails?.tolerances?.weight?.lower_tolerance);
      setOrderUpperTol(orderDetails?.tolerances?.weight?.calculated_upper_tolerance);
      setOrderLowerTol(orderDetails?.tolerances?.weight?.calculated_lower_tolerance);
    }
    if (e === "reel") {
      setCoreod(reelCoreData?.default_core_id ? (reelCoreData?.default_core_id + " " + reelCoreData?.default_core_unit) : "");
      setReelod(reelCoreData?.default_reel_od ? (reelCoreData?.default_reel_od + " " + reelCoreData?.default_reel_unit) : "");
      form.setFieldsValue({ reel_OD: reelCoreData?.default_reel_od ? (reelCoreData?.default_reel_od + " " + reelCoreData?.default_reel_unit) : "" });
      form.setFieldsValue({ core_OD: reelCoreData?.default_core_id ? (reelCoreData?.default_core_id + " " + reelCoreData?.default_core_unit) : ""});
      reelCoreData?.default_reel_od ?  setSelectedReelOD([
        {
          value:
          reelCoreData?.default_reel_od + " " + reelCoreData?.default_reel_unit,
        },
      ]) : setSelectedReelOD([]);
    }
  };

  const onLengthChange = async (e) => {
    setLength(e.target.value);
  };

  const onWidthChange = async (e) => {
    setWidth(e.target.value);
  };

  const onGrainChange = async (e) => {
    setGrain(e);
  };

  const onChangeWidthUnit = (e) => {
    setWidthUnit(e);
  };
  
  const handleProduct = (e) => {
    getProductDetails(e)
    .then((response) => {
      let currencyData = currency_List?.filter(
        (item) => response?.data.units.price === item.code
      );
      response.data["symbol"] = currencyData[0]?.symbol;
      setProductData(response.data);
      if(e === orderDetails?.product){
        setPriceUnit(orderDetails.units.per_weight_unit);
      } else{
        setPriceUnit(response?.data?.units?.per_weight_unit);
      }
    })
    .catch((error) => {
      console.log("Error in getting product specification list");
    });
  };

  const mixedGrainHandler = (e) => {
    setMixedGrain(e.target.checked);
  };

  const grainChangesHandler = (e) => {
    setGrainChanges(e.target.checked);
  };

  const handleQuantityChange = (e) => {
    setOrderQuantity(e.target.value);
    form.setFieldsValue({ weight: "" });
    form.setFieldsValue({ quantity: "" });
    form.setFieldsValue({ planning_quantity: "" });
    form.setFieldsValue({ no_of_reel_sheet: "" });
    form.setFieldsValue({ planning_weight: "" });
    form.setFieldsValue({ dealer_price: "" });
    form.setFieldsValue({ customer_price: "" });
    form.setFieldsValue({ packaging_name: "" });
    form.setFieldsValue({ remarks: ""});
    form.setFieldsValue({ minimum_reel_od: "" , max_reel_od: "", planned_weight: ""});
    form.setFieldsValue({ weightUnit: measurementData.data.units_management.weight.default });
    form.setFieldsValue({ planning_weightUnit: measurementData.data.units_management.weight.default });
    setUnitPlaceholder(measurementData.data.units_management.weight.default);
    setBalanceUnitPlaceholder(measurementData.data.units_management.weight.default);
    setWeight("");
    setReelod("");
    setQuantity("");
    setPendingQuantity("");
    setMinReel("");
    setMaxReel("");
    setPendingQntWeight("");
    setPlanningQuantityValue("");
    setPlanningWeightValue("");
    setOrderUpperTol("");
    setOrderLowerTol("");
    setDealerPriceValue();
    setPlannedReels(0);
    setPlannedWeight(0);
    setPlanningWtErr(false);
    setReelODValidationError(false);
    setCoreOdValidationError(false);
    if(e.target.value == "weight"){
      setDefaultUpperOrderTol(tolData ? (tolData?.data?.data?.settings?.order_types[2]?.data?.order_tolerance?.upper_tolerance) : "");
      setDefaultLowerOrderTol(tolData ? (tolData?.data?.data?.settings?.order_types[2]?.data?.order_tolerance?.lower_tolerance) : "");
      setOrderUpperTol(tolData ? parseFloat(tolData?.data?.data?.settings?.order_types[2]?.data?.order_tolerance?.upper_tolerance) : "");
      setOrderLowerTol(tolData ? parseFloat(tolData?.data?.data?.settings?.order_types[2]?.data?.order_tolerance?.lower_tolerance) : "");
      form.setFieldsValue({order_upper_tolerance: tolData ? (tolData?.data?.data?.settings?.order_types[2]?.data?.order_tolerance?.upper_tolerance) : ""});
      form.setFieldsValue({order_lower_tolerance: tolData ? (tolData?.data?.data?.settings?.order_types[2]?.data?.order_tolerance?.lower_tolerance) : ""});
    }
    if(selectedType?.toLowerCase() == "reel"){
      if(reelCoreData){
        setCoreod(reelCoreData.default_core_id ? (reelCoreData.default_core_id + " " + reelCoreData.default_core_unit) : "");
        setReelod(reelCoreData.default_reel_od ? (reelCoreData.default_reel_od + " " + reelCoreData.default_reel_unit) : "");
        form.setFieldsValue({ reel_OD: reelCoreData.default_reel_od ? (reelCoreData.default_reel_od + " " + reelCoreData.default_reel_unit) : "" });
        form.setFieldsValue({ core_OD: reelCoreData.default_core_id ? (reelCoreData.default_core_id + " " + reelCoreData.default_core_unit) : "" });
        reelCoreData.default_reel_od ? setSelectedReelOD([{
            value: reelCoreData.default_reel_od + " " + reelCoreData.default_reel_unit
          }]) : setSelectedReelOD([]);
      }
    }
  };

  const handleWeight = (e) => {
    setWeight(parseFloat(e.target.value));
    if(!orderMangtSettings?.data?.fetch_balance_quantity?.value){
      setPendingQuantity(e.target.value);
      setPlanningWeightValue(parseFloat(e.target.value));
      form.setFieldsValue({ planning_weight: e.target.value });
    }
    // setPlanningWeightValue(parseFloat(e.target.value));
    form.setFieldsValue({ weight: e.target.value });
    // form.setFieldsValue({ planning_weight: e.target.value });
    calculateOrderTol(
      e.target.value,
      form.getFieldValue("order_upper_tolerance"),
      "orderUpperTol"
    );
    calculateOrderTol(
      e.target.value,
      form.getFieldValue("order_lower_tolerance"),
      "orderLowerTol"
    );


    if(orderMangtSettings?.data?.fetch_balance_quantity?.value){
      let balanceQtyValue = form.getFieldValue("balance_qty");
      let balanceQtyUnitValue = form.getFieldValue("balanceQtyUnit");
      let weightUnit = form.getFieldValue("weightUnit");
      
      if((e.target.value && e.target.value != "") && balanceQtyValue && balanceQtyUnitValue){
        let valueInTonne = parseFloat(e.target.value) * conversionFactorUnitsToTonne[weightUnit];
        let targetedValueInTonne = parseFloat(balanceQtyValue) * conversionFactorUnitsToTonne[balanceQtyUnitValue];
        if(valueInTonne < targetedValueInTonne){
          setBalanceQtyErr(true);
        } else{
          setBalanceQtyErr(false);
        }
      } else{
        setBalanceQtyErr(false);
      }
    } else{
        if (
              parseFloat(form.getFieldValue("planning_weight")) &&
              parseFloat(e.target.value) <
                parseFloat(form.getFieldValue("planning_weight"))
            ) {
              setPlanningWtErr(true);
            } else {
              setPlanningWtErr(false);
            }
    }
  };

  const onChangeWeightUnit = (e) => {
    setUnitPlaceholder(e);
     if(orderMangtSettings?.data?.fetch_balance_quantity?.value){
      form.setFieldsValue({balanceQtyUnit: e});
      let balanceQtyValue = form.getFieldValue("balance_qty");
      let balanceQtyUnitValue = form.getFieldValue("balanceQtyUnit");
    
        if(weightValue && balanceQtyValue && balanceQtyUnitValue){
          let valueInTonne = parseFloat(weightValue) * conversionFactorUnitsToTonne[e];
          let targetedValueInTonne = parseFloat(balanceQtyValue) * conversionFactorUnitsToTonne[balanceQtyUnitValue];
          if(valueInTonne < targetedValueInTonne){
            setBalanceQtyErr(true);
          } else{
            setBalanceQtyErr(false);
          }
        } else{
          setBalanceQtyErr(false);
        }
     } else{
      form.setFieldsValue({ planning_weightUnit: e });
     }
  };

  const handleBalanceQty = (e) => {
    let weightValue = form.getFieldValue("weight");
    let weightUnit = form.getFieldValue("weightUnit");
    let balanceQtyUnitValue = form.getFieldValue("balanceQtyUnit");
    //check balance qty should be lesser than weight
    form.setFieldsValue({ planning_weight: e.target.value });
    setPendingQuantity(e.target.value);
    setPlanningWeightValue(parseFloat(e.target.value));

    if((e.target.value && e.target.value != "") && weightValue && weightUnit){
      let valueInTonne = weightValue * conversionFactorUnitsToTonne[weightUnit];
      let targetedValueInTonne = parseFloat(e.target.value) * conversionFactorUnitsToTonne[balanceQtyUnitValue];
      if(valueInTonne < targetedValueInTonne){
        setBalanceQtyErr(true);
      } else{
        setBalanceQtyErr(false);
      }
    }else{
      setBalanceQtyErr(false);
    }

    if (
        parseFloat(form.getFieldValue("planning_weight")) &&
        parseFloat(e.target.value) <
          parseFloat(form.getFieldValue("planning_weight"))
      ) {
        setPlanningWtErr(true);
      } else {
        setPlanningWtErr(false);
      }
  };

  const onChangeBalanceUnit = (e) => {
      setBalanceUnitPlaceholder(e);
      form.setFieldsValue({ planning_weightUnit: e });
  
      let weightValue = form.getFieldValue("weight");
      let weightUnit = form.getFieldValue("weightUnit");
      let balanceQtyValue = form.getFieldValue("balance_qty");
  
      if(balanceQtyValue && weightValue && weightUnit){
        let valueInTonne = weightValue * conversionFactorUnitsToTonne[weightUnit];
        let targetedValueInTonne = parseFloat(balanceQtyValue) * conversionFactorUnitsToTonne[e];
        if(valueInTonne < targetedValueInTonne){
          setBalanceQtyErr(true);
        } else{
          setBalanceQtyErr(false);
        }
      } else{
        setBalanceQtyErr(false);
      }
    }

  const onQuantityValueChange = (e) => {
    firstLoadRef.current = false;
    setQuantity(e.target.value);
    setPendingQuantity(e.target.value);
    if(orderQuantity == "sheet"){
      let dimensionUnit;
      if(props?.type == "deckleRecord"){
        dimensionUnit = orderDetails?.units?.width;
      } else{
        dimensionUnit = form.getFieldValue("dimensionUnit");
      }
      if(e.target.value && e.target.value != ""){
        let conversionValue = orderDim_Rewinder_Unit_Conversion[dimensionUnit];
        let calWeight = (
          ((lengthValue * conversionValue) * (widthValue * conversionValue) * parseFloat(e.target.value) * productData?.bulk)
          / (10000 * 1000000));
          let pendingWeightValue = calWeight * conversionFactorTonneToUnits[unitPlaceholder];
          let calPendingwt = pendingWeightValue ? parseFloat(pendingWeightValue)?.toFixed(3) : 0.000;
          setPendingQntWeight(calPendingwt);
      }
    }
    setPlanningQuantityValue(e.target.value);
    form.setFieldsValue({ quantity: e.target.value });
    form.setFieldsValue({ planning_quantity: e.target.value });
    if (
      parseFloat(form.getFieldValue("planning_quantity")) &&
      parseFloat(e.target.value) <
        parseFloat(form.getFieldValue("planning_quantity"))
    ) {
      setPlanningWtErr(true);
    } else {
      setPlanningWtErr(false);
    }
  };

  const onLowerTolChange = (e, type) => {
    if (type === "order_tolerance") {
      setDefaultLowerOrderTol(e.target.value);
      form.setFieldsValue({ order_lower_tolerance: e.target.value });
      calculateOrderTol(weightValue, e.target.value, "orderLoweTol");
    }
  };

  const onUpperTolChange = (e, type) => {
    if (type === "order_tolerance") {
      setDefaultUpperOrderTol(e.target.value);
      form.setFieldsValue({ order_upper_tolerance: e.target.value });
      calculateOrderTol(weightValue, e.target.value, "orderUpperTol");
    }
  };

  const calculateOrderTol = (weight, tolValue, type) => {
    if (type == "orderUpperTol") {
      if (weight && tolValue) {
        let upperTol = (weight * (100 + parseFloat(tolValue))) / 100;
        setOrderUpperTol(parseFloat(upperTol).toFixed(3));
      } else {
        setOrderUpperTol(0.0);
      }
    } else {
      if (weight && tolValue) {
        let lowerTol = (weight * (100 - parseFloat(tolValue))) / 100;
        setOrderLowerTol(parseFloat(lowerTol).toFixed(3));
      } else {
        setOrderLowerTol(0.0);
      }
    }
  };

  const onCurrencyChange = (e) => {
    let netPriceSymbol = currency_List?.filter((item) => e === item.code);
    setNetPriceSymbol(netPriceSymbol[0]?.symbol);
  };

  const handleDealerPrice = (e) => {
    setDealerPriceValue(e.target.value);
  };

  const onChangeHandlerBox = (e) => {
    setCheckedBox(e.target.checked);

    if (e.target.checked) {
      form.setFieldsValue({
        delivery_address_line_1: orderDetails?.po_details?.delivery_address_line_1,
        delivery_address_line_2: orderDetails?.po_details?.delivery_address_line_2,
        delivery_state: orderDetails?.po_details?.delivery_state,
        delivery_city: orderDetails?.po_details?.delivery_city,
        zip_code: orderDetails?.po_details?.delivery_pincode,
        delivery_country: orderDetails?.po_details?.delivery_country,
      });
    } else {
      form.setFieldsValue({
        delivery_address_line_1: "",
        delivery_address_line_2: "",
        delivery_state: "",
        delivery_city: "",
        zip_code: "",
        delivery_country: "",
      });
    }
  };

  const handlePackaging = (e) => {
    setSelectedPackaging(e);
  };

  const handleProvinceChange = (value) => {
    setCities(State.getStatesOfCountry(value));
    form.setFieldsValue({
      delivery_state: State.getStatesOfCountry(value)[0]?.name,
    });
  };

  const handlePlanningWeight = (e) => {
    setPlanningWeightValue(parseFloat(e.target.value));
    if (parseFloat(pendingQuantity) && (parseFloat(e.target.value) > parseFloat(pendingQuantity))) {
      setPlanningWtErr(true);
    } else {
      setPlanningWtErr(false);
      form.setFieldsValue({ planning_weight: e.target.value });
    }
  };

  const onPlanningQuantityValueChange = (e) => {
    firstLoadRef.current = false;
    setPlanningQuantityValue(e.target.value);
    if (
      parseFloat(pendingQuantity) &&
      (parseFloat(e.target.value) > parseFloat(pendingQuantity))
    ) {
      setPlanningWtErr(true);
    } else {
      setPlanningWtErr(false);
      form.setFieldsValue({ planning_quantity: e.target.value });
    }
  };

  const handleCoreOD = (e) => {
    // firstLoadRef.current = false;
    setCoreod(e);
    if(orderQuantity == "reel" && selectedType == "reel"){
      firstLoadRef.current = false;
      let coreodConversion = orderDim_Rewinder_Unit_Conversion[e?.split(" ")[1]];
      let reelodConversion = orderDim_Rewinder_Unit_Conversion[reelOD?.split(" ")[1]];
      let coreODValue =  (e?.split(" ")[0] * coreodConversion);
      let reelOdValue =  (reelOD?.split(" ")[0] * reelodConversion);
      if (parseFloat(coreODValue) > (reelOD && parseFloat(reelOdValue))) {
        setCoreOdValidationError(true);
      } else {
        setCoreOdValidationError(false);
      }
    } else if(outerDiameter == "constant"){
      let coreodConversion = orderDim_Rewinder_Unit_Conversion[e?.split(" ")[1]];
      let coreODValue =  (e?.split(" ")[0] * coreodConversion);
      if(selectedReelOD?.length == 1){
        firstLoadRef.current = false;
        let reelodConversion = orderDim_Rewinder_Unit_Conversion[selectedReelOD[0]?.value?.split(" ")[1]];
        let reelOdValue =  (selectedReelOD[0]?.value?.split(" ")[0] * reelodConversion);
        if (parseFloat(coreODValue) > parseFloat(reelOdValue)) {
          setCoreOdValidationError(true);
        } else {
          setCoreOdValidationError(false);
        }
      } else if(selectedReelOD?.length > 1){
        let dataArr = [];
        for(let ind = 0; ind < selectedReelOD.length; ind++){
          let convertedValue = selectedReelOD[ind]?.value?.split(" ")[0] * orderDim_Rewinder_Unit_Conversion[selectedReelOD[ind]?.value?.split(" ")[1]];
          dataArr.push(convertedValue);
        }
        let minValue = Math.min(...dataArr);
        if ((coreODValue && parseFloat(coreODValue)) > (minValue && parseFloat(minValue))){
          setCoreOdValidationError(true);
        } else{
          setCoreOdValidationError(false);
        }
      } else{
        setCoreOdValidationError(false);
      }
    } else if(outerDiameter == "range"){
      let rangeUnit = form.getFieldValue("reelOD_unit");
      let minReel = form.getFieldValue("min_reel_od");
      let minReelConversion = orderDim_Rewinder_Unit_Conversion[rangeUnit];
      let reelODValue =  (minReel * minReelConversion);
      let coreodConversion = orderDim_Rewinder_Unit_Conversion[e?.split(" ")[1]];
      let coreODValue =  (e?.split(" ")[0] * coreodConversion);

      if((reelODValue && parseFloat(reelODValue)) < (e && parseFloat(coreODValue))){
        setRangeValidationError(true);
      } else{
        setRangeValidationError(false);
      }
    }
  };

  const handleReelOD = (e) => {
    firstLoadRef.current = false;
    setReelod(e);
    let coreodConversion = orderDim_Rewinder_Unit_Conversion[coreOD?.split(" ")[1]];
    let reelodConversion = orderDim_Rewinder_Unit_Conversion[e?.split(" ")[1]];
    let coreODValue =  (coreOD?.split(" ")[0] * coreodConversion);
    let reelOdValue =  (e?.split(" ")[0] * reelodConversion);
    if (parseFloat(reelOdValue) < (coreOD && parseFloat(coreODValue))) {
      setCoreOdValidationError(true);
    } else {
      setCoreOdValidationError(false);
    }
  };

  const onChangeReelOdSelect = (data) => {
    setSelectedReelOD(data);
    let coreodConversion = orderDim_Rewinder_Unit_Conversion[coreOD?.split(" ")[1]];
    let coreODValue =  (coreOD?.split(" ")[0] * coreodConversion);
    
    if (data.length == 1) {
      firstLoadRef.current = false;
      let reelodConversion = orderDim_Rewinder_Unit_Conversion[data[0]?.value?.split(" ")[1]];
      let reelOdValue =  (data[0]?.value?.split(" ")[0] * reelodConversion);
      if ((coreOD && parseFloat(coreODValue)) > parseFloat(reelOdValue)) {
        setCoreOdValidationError(true);
      } else {
        setCoreOdValidationError(false);
      }
    } else if(data.length > 1){
      let dataArr = [];
      for(let ind = 0; ind < data.length; ind++){
       let convertedValue = data[ind]?.value?.split(" ")[0] * orderDim_Rewinder_Unit_Conversion[data[ind]?.value?.split(" ")[1]];
       dataArr.push(convertedValue);
      }
      let minValue = Math.min(...dataArr);
      if ((coreODValue && parseFloat(coreODValue)) > (minValue && parseFloat(minValue))){
        setCoreOdValidationError(true);
      } else{
        setCoreOdValidationError(false);
      }
    }
  };

  const removeReelOD = (data) => {
    let array = selectedReelOD;
    let newArray = array.filter((item) => {
      return !(item.value === data.value);
    });
    if(newArray && newArray?.length == 1){
      firstLoadRef.current = false;
    }
    setSelectedReelOD(newArray);
    let coreodConversion = orderDim_Rewinder_Unit_Conversion[coreOD?.split(" ")[1]];
    let coreODValue =  (coreOD?.split(" ")[0] * coreodConversion);
    if(newArray && newArray?.length == 1){
      let reelodConversion = orderDim_Rewinder_Unit_Conversion[newArray[0]?.value?.split(" ")[1]];
      let reelOD =  (newArray[0]?.value?.split(" ")[0] * reelodConversion);

      if ((coreODValue && parseFloat(coreODValue)) > (reelOD && parseFloat(reelOD))){
        setCoreOdValidationError(true);
      } else{
        setCoreOdValidationError(false);
      }
    } else if(newArray && newArray.length > 1){
      let dataArr = [];
      for(let ind = 0; ind < newArray.length; ind++){
       let convertedValue = newArray[ind]?.value?.split(" ")[0] * orderDim_Rewinder_Unit_Conversion[newArray[ind]?.value?.split(" ")[1]];
       dataArr.push(convertedValue);
      }
      let minValue = Math.min(...dataArr);

      if ((coreODValue && parseFloat(coreODValue)) > (minValue && parseFloat(minValue))){
        setCoreOdValidationError(true);
      } else{
        setCoreOdValidationError(false);
      }
    }
  };

  const handleRewinderType = (e) => {
    setCoreOdValidationError(false);
    setOuterDiameter(e.target.value);
    setPlannedReels(0);
    setPlannedWeight(0);
    form.setFieldsValue({no_of_reel_sheet : 0});
    form.setFieldsValue({planned_weight: 0});
    form.setFieldsValue({reelOD_unit: measurementData.data.units_management.length.default});  
  };

  const onMinReelODChange = (e) => {
    setMinReel(e.target.value);
    let rangeUnit = form.getFieldValue("reelOD_unit");
    let minReelConversion = orderDim_Rewinder_Unit_Conversion[rangeUnit];
    let reelODValue =  (e.target.value * minReelConversion);
    let coreodConversion = orderDim_Rewinder_Unit_Conversion[coreOD?.split(" ")[1]];
    let coreODValue =  (coreOD?.split(" ")[0] * coreodConversion);

    if((reelODValue && parseFloat(reelODValue)) < (coreODValue && parseFloat(coreODValue))){
      setRangeValidationError(true);
    } else{
      setRangeValidationError(false);
    }

    if (parseFloat(e.target.value) > parseFloat(form.getFieldValue("max_reel_od"))) {
      setReelODValidationError(true);
    } else {
      setReelODValidationError(false);
    }
  };

  const onRangeUnitChange = (e) => {
    setRangeUnitValue(e);
    let minReel = form.getFieldValue("min_reel_od");
    let minReelConversion = orderDim_Rewinder_Unit_Conversion[e];
    let reelODValue =  (minReel * minReelConversion);
    let coreodConversion = orderDim_Rewinder_Unit_Conversion[coreOD?.split(" ")[1]];
    let coreODValue =  (coreOD?.split(" ")[0] * coreodConversion);

    if((reelODValue && parseFloat(reelODValue)) < (coreODValue && parseFloat(coreODValue))){
      setRangeValidationError(true);
    } else{
      setRangeValidationError(false);
    }
  };

  const onMaxReelODChange = (e) => {
    setMaxReel(e.target.value);
    if (
      parseFloat(e.target.value) < parseFloat(form.getFieldValue("min_reel_od"))
    ) {
      setReelODValidationError(true);
    } else {
      setReelODValidationError(false);
    }
  };

  const onPlannedReelsChange = (e) => {
    form.setFieldsValue({ no_of_reel_sheet: e.target.value });
    setRerender(true);
  };

  const cancelChanges = () => {
    form.resetFields();
    setMixedGrain(false);
        setGrainChanges(false);
        setCoreOdValidationError(false);
        setRerender(false);
        setToleranceDisabled(false);
        setFirstLoad(false);
        setPlanningWtErr(false);
        setGrain("");
        setLength("");
        setWidth("");
        setWeight("");
        setQuantity("");
        setPlanningQuantityValue("");
        setPlanningWeightValue("");
        setSelectedPackaging("");
        setOrderUpperTol("");
        setOrderLowerTol("");
        setProductData();
        setDealerPriceValue();
        setPlannedReels(0);
        setPlannedWeight(0);
        setOrderQuantity("weight");
        setPriceUnit("");
    props.onCloseGrade();
  };

  const rewinderReelsCal = () => {
    setPlannedReels(0);
    let size;
      if((form.getFieldValue("type") === "reel") || (selectedType == "reel" && props?.type == "deckleRecord")){
        size = widthValue;
      } else{
        size = (grainValue === "Long Grain" || grainValue === "long" || grainValue === "long grain") ?
        ((parseFloat(widthValue) > parseFloat(lengthValue)) ? lengthValue : widthValue) :
        ((parseFloat(lengthValue) > parseFloat(widthValue)) ? lengthValue : widthValue);
      }

      if ( selectedType === "reel" && orderQuantity === "reel" && planningQuantityValue ) {
        if(firstLoadRef.current){
          form.setFieldsValue({ no_of_reel_sheet: planningQuantityValue });
          firstLoadRef.current = false;
        } else{
          form.setFieldsValue({ no_of_reel_sheet: planningQuantityValue });
        }
        setPlannedReels(planningQuantityValue);
        setRerender(true);        
      } else {
        if (planningWeightValue || planningQuantityValue) {
          if (
            size &&
            coreOD &&
            ((selectedReelOD && selectedReelOD?.length == 1) || reelOD) &&
            productData?.bulk &&
            size !== 0 &&
            (parseFloat(coreOD?.split(" ")[0]) !== parseFloat(selectedReelOD[0]?.value?.split(" ")[0]) || 
            (reelOD && parseFloat(coreOD?.split(" ")[0]) !== parseFloat(reelOD?.split(" ")[0])))
          ){
            let reelDiaUnit;
            let reelODValue;
            if (selectedType === "reel" && orderQuantity === "reel"){
              reelDiaUnit = reelOD?.split(" ")[1];
              reelODValue = reelOD?.split(" ")[0];
            } else{
              reelDiaUnit = selectedReelOD[0]?.value?.split(" ")[1];
              reelODValue = selectedReelOD[0]?.value?.split(" ")[0];
            }
            let reelConversionValue = orderDim_Rewinder_Unit_Conversion[reelDiaUnit];
            let coreDiaUnit = coreOD?.split(" ")[1];
            let coreConversionValue = orderDim_Rewinder_Unit_Conversion[coreDiaUnit];

            let dimensionUnit;
            if(props?.type == "deckleRecord"){
              dimensionUnit = orderDetails?.units?.width;
            } else{
              dimensionUnit = form.getFieldValue("dimensionUnit");
            }
            let conversionValue = orderDim_Rewinder_Unit_Conversion[dimensionUnit];

            // let weightUnit = form.getFieldValue("weightUnit");
            let weightConversionValue = weight_Unit_Conversions[unitPlaceholder];

            calculatePlannedReels(
              size * conversionValue,
              lengthValue * conversionValue,
              widthValue * conversionValue,
              planningWeightValue * weightConversionValue,
              productData?.bulk,
              productData?.gsm,
              coreOD?.split(" ")[0] * coreConversionValue,
              reelODValue * reelConversionValue
            );
          } else {
            setPlannedReels(0);
            form.setFieldsValue({ no_of_reel_sheet: 0 });
            setRerender(true);
          }
        } else {
          setPlannedReels(0);
          form.setFieldsValue({ no_of_reel_sheet: 0 });
          setRerender(true);
        }
      }
  };

  const calculatePlannedReels = (
    size,
    length,
    width,
    weight,
    bulk,
    gsm,
    coreOd,
    reelOd
  ) => {
    setPlannedReels(0);
    const value =
      orderQuantity === "weight"
        ? ((weight ? parseFloat(weight) : 0) *
            1000 *
            1000 *
            parseFloat(bulk) *
            4) /
          (3.14 *
            parseFloat(size) *
            (Math.pow(parseFloat(reelOd), 2) - Math.pow(parseFloat(coreOd), 2)))
        : (parseFloat(length) *
            parseFloat(width) *
            parseFloat(planningQuantityValue) *
            parseFloat(gsm) *
            parseFloat(bulk) *
            4) /
          (3.14 *
            parseFloat(size) *
            (Math.pow(parseFloat(reelOd), 2) -
              Math.pow(parseFloat(coreOd), 2)) *
            10000);

            //require changes for restore order here
            if(firstLoadRef.current){
              form.setFieldsValue({no_of_reel_sheet: orderDetails?.quantity});
              firstLoadRef.current = false;
            } else{
              form.setFieldsValue({
                no_of_reel_sheet: Math.round(value.toFixed(3))
                  ? Math.round((value * 1).toFixed(3))
                  : 1,
              });
            }            
            setPlannedReels((value * 1).toFixed(3));
            setRerender(true);
  };

  const plannedWeightCal = () => {
    setPlannedWeight(0);
    // let reels = Math.round(parseFloat(plannedReels)?.toFixed(3)) ? Math.round((parseFloat(plannedReels) * 1)?.toFixed(3)) : 1;
    let reels = form.getFieldValue("no_of_reel_sheet");
    let size;
    if (selectedType === "reel") {
      size = widthValue;
    } else {
      size =
        (grainValue === "Long Grain" || grainValue === "long" || grainValue === "long grain")
          ? parseFloat(widthValue) > parseFloat(lengthValue)
            ? lengthValue
            : widthValue
          : parseFloat(lengthValue) > parseFloat(widthValue)
          ? lengthValue
          : widthValue;
    }

    if (size && coreOD && (selectedReelOD || reelOD)) {
      let reelDiaUnit;
      let reelODValue;
      if (selectedType === "reel" && orderQuantity === "reel"){
        reelDiaUnit = reelOD?.split(" ")[1];
        reelODValue = reelOD?.split(" ")[0];
      } else{
        reelDiaUnit = selectedReelOD[0]?.value?.split(" ")[1];
        reelODValue = selectedReelOD[0]?.value?.split(" ")[0]
      }
      let reelConversionValue = orderDim_Rewinder_Unit_Conversion[reelDiaUnit];

      let coreDiaUnit = coreOD?.split(" ")[1];
      let coreConversionValue = orderDim_Rewinder_Unit_Conversion[coreDiaUnit];

      let dimensionUnit;
            if(props?.type == "deckleRecord"){
              dimensionUnit = orderDetails?.units?.width;
            } else{
              dimensionUnit = form.getFieldValue("dimensionUnit");
            }
      // let dimensionUnit = form.getFieldValue("dimensionUnit");
      let conversionValue = orderDim_Rewinder_Unit_Conversion[dimensionUnit];

      calculatePlannedWeight(
        size * conversionValue,
        productData?.bulk,
        reelODValue * reelConversionValue,
        coreOD?.split(" ")[0] * coreConversionValue,
        reels
      );
    } else{
      if (selectedType === "reel") {
        form.setFieldsValue({ planned_weight: 0 });
      } else{
        if (selectedType === "sheet" && orderQuantity === "weight") {
          if (planningWeightValue) {
            setPlannedWeight(parseFloat(planningWeightValue).toFixed(2));
            form.setFieldsValue({
              planned_weight: parseFloat(planningWeightValue).toFixed(2),
            });
          } else {
            form.setFieldsValue({ planned_weight: 0 });
          }
        } else {
          let dimensionUnit;
            if(props?.type == "deckleRecord"){
              dimensionUnit = orderDetails?.units?.width;
            } else{
              dimensionUnit = form.getFieldValue("dimensionUnit");
            }
          // let dimensionUnit = form.getFieldValue("dimensionUnit");
          let conversionValue =
            orderDim_Rewinder_Unit_Conversion[dimensionUnit];

          let length_Value = lengthValue * conversionValue;
          let width_Value = widthValue * conversionValue;

          const value =
            (length_Value *
              width_Value *
              planningQuantityValue *
              productData?.gsm) /
            (10000 * 1000000);
          let plannedWeightValue =
            value * conversionFactorTonneToUnits[unitPlaceholder];
          setPlannedWeight(plannedWeightValue ? plannedWeightValue.toFixed(3) : 0);
          form.setFieldsValue({
            planned_weight: plannedWeightValue
              ? plannedWeightValue.toFixed(3)
              : 0,
          });
        }
      }
    }
  };

  const calculatePlannedWeight = (size, bulk, reelOd, coreOd, plannedReels) => {
    const value =
      (3.14 *
        parseFloat(size) *
        (Math.pow(parseFloat(reelOd), 2) - Math.pow(parseFloat(coreOd), 2)) *
        parseFloat(plannedReels)) /
      (1000 * 1000 * parseFloat(bulk) * 4);
      let plannedWeightValue = value * conversionFactorTonneToUnits[unitPlaceholder];
    setPlannedWeight(plannedWeightValue ? plannedWeightValue.toFixed(3) : 0);
    form.setFieldsValue({
      planned_weight: plannedWeightValue ? plannedWeightValue.toFixed(3) : 0,
    });
  };

  const calculateNetPrice = () => {
    if(productData){
      let requiredWeightValue;

      if(orderQuantity == "weight"){
        requiredWeightValue = weightValue;
      } else {
        // requiredWeightValue = ((selectedReelOD && selectedReelOD?.length == 1) || (selectedReelOD?.length == 0) || (selectedType == "reel" && orderQuantity == "reel")) ? plannedWeight : 0;
        if(orderQuantity == "sheet" && selectedType === "sheet"){
          let dimensionUnit = form.getFieldValue("dimensionUnit");
          let conversionValue = orderDim_Rewinder_Unit_Conversion[dimensionUnit];

          let length_Value = lengthValue * conversionValue;
          let width_Value = widthValue * conversionValue;
          let calWeightInTonn = (length_Value * width_Value * quantityValue * productData?.gsm) / ( 10000 * 1000000);
          let convertedWt = calWeightInTonn * conversionFactorTonneToUnits[unitPlaceholder];
          requiredWeightValue = parseFloat(convertedWt)?.toFixed(3);
        }
      }

      let plannedWtConversion;
      if(unitPlaceholder?.toLowerCase() !== priceUnit?.toLowerCase()){
        let unitToTonneConv = requiredWeightValue * weight_Unit_Conversions[unitPlaceholder];
        plannedWtConversion  = unitToTonneConv * conversionFactorTonneToUnits[priceUnit];
      } else{
        plannedWtConversion  = requiredWeightValue;
      }

      const netPrice = parseFloat(dealerPriceValue) * parseFloat(plannedWtConversion)
        ? parseFloat(dealerPriceValue) * parseFloat(plannedWtConversion)
        : "";

      if (netPrice){
        setNetPrice(parseFloat(netPrice).toFixed(3));
      } else{
        setNetPrice("");
      }

    }
  };

  const onMergeOrderHandler = () => {
     props.setMergeSideDrawer();
  };

  const handleRestore = () => {
    props.handleRestore(true);
  };

  const handleCancel = () => {
    props.handleCancel();
    setMixedGrain(false);
      setGrainChanges(false);
      setCoreOdValidationError(false);
      setRerender(false);
      setToleranceDisabled(false);
      setFirstLoad(false);
      setPlanningWtErr(false);
      setGrain("");
      setLength("");
      setWidth("");
      setWeight("");
      setQuantity("");
      setPlanningQuantityValue("");
      setPlanningWeightValue("");
      setSelectedPackaging("");
      setOrderUpperTol("");
      setOrderLowerTol("");
      setProductData();
      setDealerPriceValue();
      setPlannedReels(0);
      setPlannedWeight(0);
      setOrderQuantity("weight");
      setPriceUnit("");
  };

 
  const onViewPODetailsHandler = () => {
    props?.category==='po'?history("../po-details", {
      state: {
        poNumber: props?.selectedOrder?.savedPO,
        backKey: "orderRecords",
        customer: props?.selectedOrder?.customercode
      },
    }):history("../so-details", {
      state: {
        soNumber: props?.selectedOrder?.sono,
        backKey: props?.type==='approveOrder'? "../approve-records":"../order-records",
        isView:true
      },
    })
  };

  const onViewChangeHandler = () => {
    history("../history", {
      state: {
        order: {
          orderDetails: props.selectedOrder,
          route: props.pageType === "orderRecord" ? "../order-records" : props.pageType === "approveOrder" ? "../approve-records" : "../order-details",
          PORoute : props?.route ,
          backKey : props?.backKey ,
          values : props?.values,
          defaultActiveKey : props?.defaultActiveKey,
          defaultOrderState : props?.defaultOrderState
        },
        logType: "Order",
        name: props.selectedOrder.orderno,
        searchText: "Search change in order property",
      },
    });
  };

  const handleDelete = () => {
    setIsVisibleDeleteModal(true);
  };

  const deleteModalClose = () => {
    setIsVisibleDeleteModal(false);
    setMixedGrain(false);
      setGrainChanges(false);
      setCoreOdValidationError(false);
      setRerender(false);
      setToleranceDisabled(false);
      setFirstLoad(false);
      setPlanningWtErr(false);
      setGrain("");
      setLength("");
      setWidth("");
      setWeight("");
      setQuantity("");
      setPlanningQuantityValue("");
      setPlanningWeightValue("");
      setSelectedPackaging("");
      setOrderUpperTol("");
      setOrderLowerTol("");
      setProductData();
      setDealerPriceValue();
      setPlannedReels(0);
      setPlannedWeight(0);
      setOrderQuantity("weight");
      setPriceUnit("");
    props.onClose();
  };

  const deleteModalConfirm = (orderNo) => {
    setIsVisibleDeleteModal(false);
    deleteOrder(orderNo)
      .then((response) => {
        props.isDeleted && props.isDeleted(true);
        props.rendering(true);
        props.toasterAction({
          error: response.error,
          msg: `Order ${orderNo} was successfully deleted`,
        });
        props.showToaster();
      })
      .catch((error) => {
        console.log("Error in deleting order:", error);
        props.toasterAction({
          error: error.response.error,
          msg: error.response.msg,
        });
        props.showToaster();
        props.onClose();
      });
    props.onClose();
  };

  const handlePriorityAction = (record) => {
    setIsVisiblePriorityModal(true);
  };

  const priorityModalConfirm = async (value) => {
    await prioritizeOrder(value);
    setIsVisiblePriorityModal(false);
  };

  const priorityModalClose = () => {
    setIsVisiblePriorityModal(false);
    setMixedGrain(false);
      setGrainChanges(false);
      setCoreOdValidationError(false);
      setRerender(false);
      setToleranceDisabled(false);
      setFirstLoad(false);
      setPlanningWtErr(false);
      setGrain("");
      setLength("");
      setWidth("");
      setWeight("");
      setQuantity("");
      setPlanningQuantityValue("");
      setPlanningWeightValue("");
      setSelectedPackaging("");
      setOrderUpperTol("");
      setOrderLowerTol("");
      setProductData();
      setDealerPriceValue();
      setPlannedReels(0);
      setPlannedWeight(0);
      setOrderQuantity("weight");
      setPriceUnit("");
    props.onClose();
  };

  const prioritizeOrder = async (record) => {
    await changeOrderPriority({
      order: record.orderno,
      prioritize: !record.priority,
    })
      .then((response) =>{
        props.rendering(true)
        props.toasterAction({
          error: response.error,
          msg: response.msg,
        });
        props.showToaster();
     })
      .catch((error) => {
        console.log("Error in deleting order:", error);
        props.toasterAction({
          error: error.response.data.error,
          msg: error.response.data.msg,
        });
        props.showToaster();
        props.onClose();
      });
      props.onClose();
  };

  const handleViewProdDetails = () => {
    props?.handleViewProdDrawer(props?.selectedOrder);
  };

  const handleViewProcessedQtyDetails = () => {
    props?.handleViewProcessedQtyDrawer(props?.selectedOrder);
  };

  const handleViewPendingQtyDetails = () => {
    props?.handleViewPendingQtyDrawer(props?.selectedOrder);
  };

  const onCancelQuantityHandler = () => {
    props?.handleCancelQuantity(props?.selectedOrder);
  };

  const splitOrderHandler = () => {
    props?.handleSplitDrawer();
    setMixedGrain(false);
      setGrainChanges(false);
      setCoreOdValidationError(false);
      setRerender(false);
      setToleranceDisabled(false);
      setFirstLoad(false);
      setPlanningWtErr(false);
      setGrain("");
      setLength("");
      setWidth("");
      setWeight("");
      setQuantity("");
      setPlanningQuantityValue("");
      setPlanningWeightValue("");
      setSelectedPackaging("");
      setOrderUpperTol("");
      setOrderLowerTol("");
      setProductData();
      setDealerPriceValue();
      setPlannedReels(0);
      setPlannedWeight(0);
      setOrderQuantity("weight");
      setPriceUnit("");
  };

  const handleHold = (data) => {
   props?.handleHold(data);
  };

  const handleRelease = () => {
    setIsVisibleReleaseModal(true);
  };

  const releaseModalConfirm = async (value) => {
    await approveOrder(value.orderno);
    setIsVisibleReleaseModal(false);
  };

  const approveOrder = async (orderNo) => {
    await bulkChangeOrderState([{ order: orderNo, state: "approved" }])
      .then((response) => {
        props.rendering(true)
        props.toasterAction({
          error: response.error,
          msg: response.msg,
        });
        props.showToaster();
        }
      )
      .catch((error) => {
        console.log(error);
      });
      props.onClose();
  };

  const releaseModalClose = () => {
    setIsVisibleReleaseModal(false);
    setMixedGrain(false);
      setGrainChanges(false);
      setCoreOdValidationError(false);
      setRerender(false);
      setToleranceDisabled(false);
      setFirstLoad(false);
      setPlanningWtErr(false);
      setGrain("");
      setLength("");
      setWidth("");
      setWeight("");
      setQuantity("");
      setPlanningQuantityValue("");
      setPlanningWeightValue("");
      setSelectedPackaging("");
      setOrderUpperTol("");
      setOrderLowerTol("");
      setProductData();
      setDealerPriceValue();
      setPlannedReels(0);
      setPlannedWeight(0);
      setOrderQuantity("weight");
      setPriceUnit("");
    props.onClose();
  };

  useEffect(() => {
    if(selectedType&&selectedPly){
    (async () => {
      getProducts({ status: "active", type: selectedType,ply:selectedPly,isPly:true })
        .then((response) => {
          setProducts(response);
        })
        .catch((error) => {
          console.log("Error in fetching products list:", error);
        });

      getMachineGradeSelect()
        .then((response) => {
          setTolData(response);
          const reelValue = response.data.data.settings.order_types[0].value;
          const sheetValue = response.data.data.settings.order_types[1].value;
          setToleranceDisabled(response.data.data.settings.order_types[2].value);
          const typeData =
            reelValue && sheetValue
              ? [
                  { label: "Reel", value: "reel" },
                  { label: "Sheet", value: "sheet" },
                ]
              : reelValue
              ? [{ label: "Reel", value: "reel" }]
              : sheetValue
              ? [{ label: "Sheet", value: "sheet" }]
              : [];
          setOrderTypes(typeData);
        })
        .catch((error) => console.log(error));

      try {
        const unitData = await getUnitData();
        if (!unitData.error) {
          setMeasurementData(unitData);
          setDimesionUnitList(unitData.data.units_management.length.data);
          setWeightUnitList(unitData.data.units_management.weight.data);
          let currencyData = currency_List?.filter((item) =>
            unitData.data.units_management.currency.data.includes(item.code)
          );
          setCurrencyUnitData(currencyData);
        }
      } catch (err) {
        console.log(err);
      }

      try {
        const response = await getReelCoreValues();
        if (!response.error) {
          setReelCoreData(response);
          const reelData = response.reel_data.map((item) => {
            return {
              value: item[0] + " " + item[1],
            };
          });
          const coreData = response.core_data.map((item) => {
            return {
              value: item[0] + " " + item[1],
            };
          });
          setCoreValues(coreData);
          setReelvalues(reelData);
        }
      } catch (error) {
        console.log(error);
      }
      
      let orderMangtSettings = await getWorkflowSettings("order_management");
      setOrderMangtSettings(orderMangtSettings);

    })();
  }
  }, [selectedPly,selectedType]);

  useEffect(() => {
    if (props?.selectedOrderNo) {
      if (props.type == "orderRecord") {
        getAllOrdersListByOrderno(props.selectedOrderNo)
          .then((response) => {
            setOrderDetails(response.data);
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        getAllDeckleMatchingOrdersListByOrderno(props?.selectedOrderNo)
          .then((response) => {
            setOrderDetails(response.data);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }
    return () => setOrderDetails();
  }, [props]);

  useEffect(() => {
    form.resetFields();
    if (orderDetails) {
      orderDetails.use_po_address ? setCheckedBox(true) : setCheckedBox(false);

      form.setFieldsValue({
        delivery_address_line_1: orderDetails?.delivery_address_line_1,
        delivery_address_line_2: orderDetails?.delivery_address_line_2,
        delivery_state: orderDetails?.delivery_state,
        delivery_city: orderDetails?.delivery_city,
        zip_code: orderDetails?.delivery_pincode,
        delivery_country: orderDetails?.delivery_country,
      });

      setOrderQuantityTab([
        { label: "Weight", value: "weight" },
        {
          label: orderDetails?.type
            ? `${capitalize(orderDetails?.type)}s`
            : "Reels/Sheets",
          value: orderDetails?.type,
        },
      ]);

      let netPriceSymbol = currency_List?.filter(
        (item) =>
        orderDetails?.units?.net_price == item.code
      );

      setNetPriceSymbol(netPriceSymbol[0]?.symbol);
      setPriceUnit(orderDetails?.units?.per_weight_unit);
      setMixedGrain(orderDetails?.grain_mixing);
      setGrainChanges(orderDetails?.rotation);
      setWidthUnit(orderDetails?.units?.width);
      setPlannedWeight(orderDetails?.planned_weight);
      setOuterDiameter(orderDetails?.id_od_type);
      setPlanningWeightValue(orderDetails?.planning_weight);
      setPlanningQuantityValue(orderDetails?.planning_quantity);
      if(orderDetails?.quantity_type == "reel_sheet"){
        setPendingQuantity(orderDetails?.total_pending_quantity?.quantity);
        setPendingQntWeight(orderDetails?.total_pending_quantity?.weight);
      } else{
        setPendingQuantity(orderDetails?.total_pending_quantity?.weight);
      }

      if (orderDetails?.quantity_type === "weight") {
        setOrderQuantity("weight");
        setUnitPlaceholder(orderDetails?.units.weight ? orderDetails?.units.weight : orderDetails?.units.planned_weight);
        setBalanceUnitPlaceholder(orderDetails?.units.balance_weight ? orderDetails?.units?.balance_weight : orderDetails?.units.planned_weight);
        form.setFieldsValue({order_upper_tolerance: orderDetails?.tolerances?.weight?.upper_tolerance});
        form.setFieldsValue({order_lower_tolerance: orderDetails?.tolerances?.weight?.lower_tolerance});
        setDefaultUpperOrderTol(orderDetails?.tolerances?.weight?.upper_tolerance);
        setDefaultLowerOrderTol(orderDetails?.tolerances?.weight?.lower_tolerance);
        setOrderUpperTol(orderDetails?.tolerances?.weight?.calculated_upper_tolerance);
        setOrderLowerTol(orderDetails?.tolerances?.weight?.calculated_lower_tolerance);
      } else {
        setOrderQuantity(orderDetails?.type);
        if(orderDetails?.type == "reel"){
          setUnitPlaceholder( measurementData?.data?.units_management?.weight.default);
        } else{
          setUnitPlaceholder(orderDetails?.units?.weight ? orderDetails?.units?.weight : orderDetails?.units?.planned_weight);
        }
      }
      orderDetails?.grain?.toLowerCase() === "long" ? setGrain("Long Grain") : setGrain("Short Grain");
      if(orderDetails?.type == "reel" && orderDetails?.quantity_type == "reel_sheet"){
        if(orderDetails?.outer_dia?.length){
          setReelod(orderDetails?.outer_dia[0]);
          setSelectedReelOD([orderDetails?.outer_dia[0]]);
          form.setFieldsValue({ reel_OD: orderDetails?.outer_dia[0] });
        } else{
          setReelod("");
          setSelectedReelOD([]);
          // form.setFieldsValue({ reel_OD: });
        }
      } else{
        let outerDiaArr = [];
        if(orderDetails?.outer_dia?.length){
          for(let i = 0; i < orderDetails?.outer_dia.length; i++){
            let outerDiaObj = {};
            outerDiaObj["value"] = orderDetails?.outer_dia[i];
            outerDiaArr.push(outerDiaObj);
          }
          setSelectedReelOD(outerDiaArr);
        } else{
          setSelectedReelOD(outerDiaArr);
        }
      }
      setCoreod(orderDetails?.inner_dia);
      form.setFieldsValue({ core_OD: orderDetails?.inner_dia });

      let processQuantity;
      if (orderDetails.type == "reel" && orderDetails.quantity_type == "reel_sheet") {
        processQuantity = orderDetails.this_item_type == 'order' ? Math.round(orderDetails.total_processed_quantity.quantity) : Math.round(orderDetails.total_processed_quantity.quantity);
      } else if (orderDetails.type == "sheet" && orderDetails.quantity_type == "reel_sheet") {
         processQuantity = orderDetails.this_item_type == 'order' ? orderDetails.total_processed_quantity.weight : orderDetails.total_processed_quantity.weight;
      } else if ((orderDetails.type == "reel" || orderDetails.type == "sheet") && orderDetails.quantity_type == "weight") {
        processQuantity = orderDetails.this_item_type == 'order' ? orderDetails.total_processed_quantity.weight : orderDetails.total_processed_quantity.weight;
      }

      if(orderDetails?.id_od_type == "range"){
        setMinReel(orderDetails?.minimum_reel_od ? orderDetails?.minimum_reel_od : 0);
        setMaxReel(orderDetails?.maximum_reel_od ? orderDetails?.maximum_reel_od : 0);
        setRangeUnitValue(orderDetails?.units?.minimum_reel_od ? orderDetails?.units?.minimum_reel_od : "cm");
      }

      setDetails({
        orderno: orderDetails.number,
        user: orderDetails.user,
        pono: orderDetails.po,
        productSpec: orderDetails.product_spec,
        type: orderDetails.type,
        grain: `${orderDetails.grain}`.toLowerCase(),
        length: orderDetails.length,
        width: orderDetails.width,
        weight: orderDetails.weight,
        quantity:
          orderDetails.type === "reel" &&
          orderDetails.quantity_type === "reel_sheet"
            ? parseInt(orderDetails.no_of_reel_sheet)
            : orderDetails.quantity
            ? orderDetails.quantity
            : 0,
        core_od: orderDetails.core_id ? orderDetails.core_id : "",
        reel_od: orderDetails.reel_od ? orderDetails.reel_od : "",
        price: parseFloat(orderDetails.quoted_price)
          ? parseFloat(orderDetails?.quoted_price).toFixed(3)
          : "",
        net_price: parseFloat(orderDetails?.net_price)
          ? parseFloat(orderDetails?.net_price).toFixed(3)
          : "",
        currency: orderDetails.currency,
        delivery_date: moment(orderDetails.delivery_date).format("DD MM YYYY"),
        delivery_address_line_1: orderDetails.delivery_address_line_1,
        delivery_address_line_2: orderDetails.delivery_address_line_2,
        delivery_state: orderDetails.delivery_state,
        delivery_city: orderDetails.delivery_city,
        delivery_pincode: orderDetails.delivery_pincode,
        delivery_country: orderDetails.delivery_country,
        remarks: orderDetails.remarks,
        priority: orderDetails.forced,
        state: orderDetails.state,
        product_code: orderDetails.product,
        quantityType: orderDetails.quantity_type,
        plannedWeight: orderDetails?.planned_weight
          ? parseFloat(orderDetails.planned_weight).toFixed(3)
          : 0,
        no_of_reel_sheet: parseInt(orderDetails.no_of_reel_sheet),
        comment: orderDetails.comments.length
          ? orderDetails.comments[orderDetails.comments.length - 1]
          : "",
        reel_diameter: orderDetails?.reel_diameter,
        calculated_lower_tolerance: orderDetails?.tolerances?.calculated_lower_tolerance ? orderDetails.tolerances.calculated_lower_tolerance : "",
        calculated_upper_tolerance: orderDetails?.tolerances?.calculated_upper_tolerance ? orderDetails.tolerances.calculated_upper_tolerance : "",
        grain_mixing: orderDetails?.grain_mixing,
        rotation: orderDetails?.rotation,
        upper_tolerance: orderDetails?.tolerances?.upper_tolerance ? orderDetails.tolerances.upper_tolerance : "",
        lower_tolerance: orderDetails?.tolerances?.lower_tolerance ? orderDetails.tolerances.lower_tolerance : "",
        dealer_price: orderDetails?.dealer_price,
        customer_price: orderDetails?.customer_price,
        packaging_details: orderDetails?.packaging_details,
        total_pending_quantity: orderDetails?.total_pending_quantity,
        pending_quantity: orderDetails.pending_quantity,
        planned_sheets: orderDetails?.planned_sheets,
        planning_weight: orderDetails?.planning_weight,
        planning_quantity: orderDetails?.planning_quantity,
        minimum_reel_od: orderDetails?.minimum_reel_od,
        maximum_reel_od: orderDetails?.maximum_reel_od,
        completed: orderDetails.completed,
        inProcess: orderDetails.in_process,
        inProduction: orderDetails.in_production,
        units: orderDetails?.units,
        progressbar_info: orderDetails?.progressbar_info,
        processQuantity: processQuantity,
        ply: orderDetails?.ply,
        balance_weight: orderDetails?.balance_weight,
      });
      setSelectedPly(orderDetails?.ply);
      setSelectedType(orderDetails?.type);
    }
    return () => {
      setDetails();
    };
  }, [orderDetails]);

  useEffect(() => {
    if(products.length && orderDetails){
      let selectedProd = products?.filter((item) => item.code === orderDetails?.product);
      setProductData(selectedProd[0]);
      setFirstLoad(true);
    }
  },[orderDetails, products]);

  useEffect(() => {
    (async () => {
      if (selectedType) {
        try {
          const resp = await getPackagingList(selectedType, "active");
          if (!resp.error) {
            setPackagingData(resp.data);
          }
        } catch (err) {
          console.log(err);
        }
      }
    })();
  }, [selectedType]);

  useEffect(() => {
    if(isFirstLoad && details && productData?.gsm){
      if(orderDetails?.type === "sheet"){
        setLength(orderDetails?.length);
        setGrain(orderDetails?.grain?.toLowerCase());
      }
      orderDetails?.width ? setWidth(orderDetails?.width) : setWidth(0);
      if(orderDetails?.type == "reel" && orderDetails?.quantity_type == "reel_sheet"){
        orderDetails?.outer_dia.length ? setReelod(orderDetails?.outer_dia[0]) : setReelod("");
      } else{
        let outerDiaArr = [];
        for(let i = 0; i < orderDetails?.outer_dia.length; i++){
          let outerDiaObj = {};
          outerDiaObj["value"] = orderDetails?.outer_dia[i];
          outerDiaArr.push(outerDiaObj);
        }
        setSelectedReelOD(outerDiaArr);
      }
      orderDetails?.inner_dia ? setCoreod(orderDetails?.inner_dia) : setCoreod("");
      orderDetails?.quantity_type === "weight"? setWeight(orderDetails?.weight) : setWeight("");
      orderDetails?.quantity_type === "reel_sheet"? setQuantity(orderDetails?.no_of_reel_sheet) : setQuantity("");
      orderDetails?.planning_weight ? setPlanningWeightValue(orderDetails?.planning_weight) : setPlanningWeightValue("");
      orderDetails?.planning_quantity ? setPlanningQuantityValue(orderDetails?.planning_quantity) : setPlanningQuantityValue("");
      orderDetails?.dealer_price ? setDealerPriceValue(orderDetails?.dealer_price) : setDealerPriceValue("");
    } else{
        setLength("");
        setGrain("");
        setWidth("");
        setCoreod("");
        setReelod("");
        setWeight("");
        setQuantity("");
        setPlanningWeightValue("");
        setPlanningQuantityValue("");
    }
  },[isFirstLoad]);
  
  useEffect(() => {
    setPlannedWeight(0);
    if (((selectedReelOD && selectedReelOD?.length == 1) || ((reelOD || form.getFieldValue('reel_OD')) && orderQuantity == "reel")) && (coreOD || form.getFieldValue('core_OD')) && widthValue) {
      rewinderReelsCal();
    } else if(((!coreOD || !selectedReelOD) || (coreOD || !selectedReelOD) || (!coreOD || selectedReelOD)) && selectedType == "sheet"){
      if (selectedType === "sheet" && orderQuantity === "weight") {
        if(planningWeightValue){
          setPlannedWeight(parseFloat(planningWeightValue).toFixed(3));
          form.setFieldsValue({planned_weight: parseFloat(planningWeightValue).toFixed(3)});
        } else{
          setPlannedWeight(0.000);
          form.setFieldsValue({planned_weight: 0});
        }
      } else {
          let divisorDimension = orderDim_Rewinder_Unit_Conversion[widthUnit];
          let length_Value = lengthValue * divisorDimension;
          let width_Value = widthValue * divisorDimension;
          const value = ((length_Value * width_Value * planningQuantityValue * productData?.gsm) / (10000 * 1000000));
          let plannedWeightValue =  value * conversionFactorTonneToUnits[unitPlaceholder];
          setPlannedWeight(plannedWeightValue ? plannedWeightValue?.toFixed(3) : 0);
          form.setFieldsValue({planned_weight: plannedWeightValue ? plannedWeightValue.toFixed(3) : 0});
      }
      form.setFieldsValue({ no_of_reel_sheet: 0 });
    } else{
      if(selectedType === "reel" && orderQuantity === "reel" && planningQuantityValue){
        form.setFieldsValue({ no_of_reel_sheet: planningQuantityValue });
      } else{
        form.setFieldsValue({no_of_reel_sheet: 0});
      }
      setPlannedReels(0);
      setRerender(true);
    }
  }, [
    widthValue,
    coreOD,
    planningWeightValue,
    planningQuantityValue,
    lengthValue,
    grainValue,
    productData,
    selectedReelOD,
    unitPlaceholder,
    widthUnit,
    reelOD,
    outerDiameter
  ]);

  useEffect(() => {
    if (rerender) {
      plannedWeightCal();
      setRerender(false);
    }
  }, [rerender]);

  useEffect(() => {
    calculateNetPrice();
    // console.log('props',props);
    
  }, [dealerPriceValue, plannedWeight, weightValue, selectedReelOD]);

  return details?.type &&
    orderTypes.length &&
    measurementData &&
    orderQuantityTab ? (
    <RightDrawerSidebar
      title={`Order Details -#${details?.orderno}`}
      subtitle=""
      visible={props.visible}
      onClose={handleClose}
    >
      <RightDrawerContainer>
        <div className="resetPassForm removePadLeft">
          <DetailFields className="marginBtnP">
            <HaberForm>
              {/* {(details?.priority ||
                ["rejected", "review", "hold"].includes(details?.state)) && ( */}
              <div className="drawerFieldAlert">
                <div className="titleWithText" style={{}}>
                  {/* Priority Order means need to show this blue alert box */}
                  {details?.priority && (
                    <>
                      <h5
                        style={{
                          paddingTop: 0,
                        }}
                      >
                        Priority Order
                      </h5>
                      <AlertContainer
                        color="blue"
                        icon={alertBlue}
                        msg="This Order is prioritized by the approver"
                      />
                    </>
                  )}
                  {details?.state !== "open" &&
                    details?.state !== "approved" && (
                      <>
                        <h5
                          style={{
                            paddingTop: 0,
                            paddingBottom: 20,
                          }}
                        >
                          {details?.state === "review"
                            ? "Requested Changes"
                            : details?.state === "rejected"
                            ? "Reason for Rejection"
                            : details?.state === "hold"
                            ? "Reason for Holding Order"
                            : details?.state == "cancel"
                            ? "Reason for Cancelling Order"
                            : ""}
                        </h5>
                        {details?.comment && (
                          <AlertContainer
                            color={
                              details?.state === "review" ? "yellow" : "red"
                            }
                            icon={
                              details?.state === "review"
                                ? alertYellow
                                : alertRed
                            }
                            msg={details?.comment}
                          />
                        )}
                      </>
                    )}
                </div>
              </div>
              {/* )} */}
              <Form
                name="basic"
                autoComplete="off"
                className="haberLogin haberSignup"
                style={{ marginTop: "0" }}
                onFinish={onFinish}
                form={form}
              >
                {(props?.type == "orderRecord" ||
                  (props?.type == "deckleRecord" &&
                    props?.actionType == "view") ||
                  (props?.type == "approveOrder" &&
                    props?.actionType == "view")) && (
                  <div className="drawerField">
                    <div className="titleWithText">
                      <h5>Order type</h5>
                      <p>The order can be of reel or sheet type</p>
                    </div>
                    <Form.Item
                      name="type"
                      rules={[
                        {
                          required: true,
                          message: "This field is required",
                        },
                      ]}
                      className="selectForm"
                      initialValue={details?.type}
                    >
                      <Select
                        placeholder="Select"
                        suffixIcon={<DownArrowDraw />}
                        onChange={handleType}
                        disabled={
                          props?.actionType == "view" ||
                          details?.progressbar_info?.completed?.weight > 0 ||
                          details?.progressbar_info?.in_production?.weight > 0
                        }
                      >
                        {orderTypes.map((orderType) => (
                          <Option key={orderType.value}>
                            {orderType.label}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                )}
 {(props?.type == "orderRecord" ||
                  (props?.type == "deckleRecord" &&
                    props?.actionType == "view") ||
                  (props?.type == "approveOrder" &&
                    props?.actionType == "view" &&
                    selectedType == "reel")) && (
                  <div className="drawerField">
                    <div className="titleWithText">
                      <h5>Ply Count</h5>
                      <p>Count of ply in the product to be produced</p>
                    </div>
                    <Form.Item
                      name="ply"
                      rules={[
                        {
                          required: true,
                          message: "This field is required",
                        },
                      ]}
                      className="selectForm"
                      initialValue={details?.ply}
                    >
                      <Select
                        placeholder="Select Ply"
                        suffixIcon={ <DownArrowDraw />}
                        showSearch
                        optionFilterProp="children"
                        disabled={
                          props?.actionType == "view" ||
                          details?.progressbar_info?.completed?.weight > 0 ||
                          details?.progressbar_info?.in_production?.weight > 0
                        }
                        onChange={handlePlyChange}
                      >
                        {plyData.map((item) => (
                          <Option key={item.value} value={item.value}>{item.label}</Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                )}
                {(props?.type == "orderRecord" ||
                  (props?.type == "deckleRecord" &&
                    props?.actionType == "view") ||
                  (props?.type == "approveOrder" &&
                    props?.actionType == "view")) && (
                  <div className="drawerField">
                    <div className="titleWithText">
                      <h5>Product</h5>
                      <p>Product name and specifications which will define</p>
                    </div>
                    <Form.Item
                      name="product_code"
                      rules={[
                        {
                          required: true,
                          message: "This field is required",
                        },
                      ]}
                      className="selectForm"
                      initialValue={details?.product_code}
                    >
                      <Select
                        placeholder="Select Product"
                        suffixIcon={<DownArrowDraw />}
                        showSearch
                        optionFilterProp="children"
                        onChange={handleProduct}
                        disabled={
                          props?.actionType == "view" ||
                          details?.progressbar_info?.completed?.weight > 0 ||
                          details?.progressbar_info?.in_production?.weight > 0
                        }
                      >
                        {products?.map((product) => (
                          <Option key={product.code}>
                            {product.code} - {product.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <div className="titleWithText">
                      {productData ? (
                        <div style={{ marginTop: "-20px" }}>
                          <p>
                            {productData.grade +
                              " / " +
                              productData.quality +
                              (productData?.gsm ||
                              productData?.burst_factor ||
                              productData?.moisture
                                ? " / "
                                : "") +
                              (productData?.gsm ? productData.gsm : "") +
                              (productData?.burst_factor
                                ? " / " + productData.burst_factor
                                : "") +
                              (productData?.moisture
                                ? " / " + productData.moisture
                                : "")}
                            <Styled style={{ display: "inline-flex" }}>
                              <Tooltip
                                placement="bottomRight"
                                title={
                                  "Grade: " +
                                  productData.grade +
                                  "\n" +
                                  "Quality: " +
                                  productData.quality +
                                  "\n" +
                                  (productData?.gsm
                                    ? "GSM: " + productData.gsm + "\n"
                                    : "") +
                                  (productData?.burst_factor
                                    ? "BF: " + productData.burst_factor + "\n"
                                    : "") +
                                  (productData?.moisture
                                    ? "Moisture: " + productData.moisture
                                    : "")
                                }
                                className="edit-tooltip"
                                getPopupContainer={(triggerNode) => triggerNode}
                              >
                                <span className="infoIcon"></span>
                              </Tooltip>
                            </Styled>
                          </p>
                        </div>
                      ) : null}
                    </div>
                  </div>
                )}

               

                {(props?.type == "orderRecord" ||
                  (props?.type == "deckleRecord" &&
                    props?.actionType == "view") ||
                  (props?.type == "approveOrder" &&
                    props?.actionType == "view")) && (
                  <div className="drawerField removeStar">
                    <div className="titleWithText">
                      <h5>Order Size</h5>
                      <p>
                        {selectedType === "reel" ? (
                          <>The width of the order</>
                        ) : (
                          <>The width and length of the order</>
                        )}
                      </p>
                    </div>
                    <Row className="centerAlign justifyCSBetween">
                      {(selectedType === "sheet" ||
                        form.getFieldValue("type") !== "reel") && (
                        <Col span={8}>
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item
                              label="Length"
                              name="length"
                              rules={[
                                {
                                  required:
                                    selectedType === "sheet" ||
                                    orderTypes[0]?.value === "sheet"
                                      ? true
                                      : false,
                                  message: "This field is required",
                                },
                                {
                                  pattern: new RegExp(/^\d+(\.\d{0,2})?$/),
                                  message:
                                    "Upto 2 decimal point values is accepted",
                                },
                                {
                                  pattern: new RegExp(
                                    /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                                  ),
                                  message:
                                    "Length should be a number greater than zero",
                                },
                              ]}
                              className="dBlock"
                              initialValue={details?.length}
                            >
                              <Input
                                placeholder="Length"
                                onChange={(e) => {
                                  onLengthChange(e);
                                }}
                                disabled={
                                  props?.actionType == "view" ||
                                  details?.progressbar_info?.completed?.weight >
                                    0 ||
                                  details?.progressbar_info?.in_production
                                    ?.weight > 0
                                }
                              />
                            </Form.Item>
                          </div>
                        </Col>
                      )}
                      <Col
                        span={
                          selectedType === "sheet" ||
                          form.getFieldValue("type") !== "reel"
                            ? 8
                            : 13
                        }
                      >
                        <div className="boxFormType">
                          <Form.Item
                            label="Width"
                            name="width"
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                              {
                                pattern: new RegExp(/^\d+(\.\d{0,2})?$/),
                                message:
                                  "Upto 2 decimal point values is accepted",
                              },
                              {
                                pattern: new RegExp(
                                  /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                                ),
                                message:
                                  "Width should be a number greater than zero",
                              },
                            ]}
                            className="dBlock"
                            initialValue={details?.width}
                          >
                            <Input
                              placeholder="Width"
                              onChange={(e) => {
                                onWidthChange(e);
                              }}
                              disabled={
                                props?.actionType == "view" ||
                                details?.progressbar_info?.completed?.weight >
                                  0 ||
                                details?.progressbar_info?.in_production
                                  ?.weight > 0
                              }
                            />
                          </Form.Item>
                        </div>
                      </Col>
                      <Col
                        span={
                          selectedType === "sheet" ||
                          form.getFieldValue("type") !== "reel"
                            ? 7
                            : 10
                        }
                      >
                        <div className="boxFormType unitSelect">
                          <Form.Item
                            label="Unit"
                            name="dimensionUnit"
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                            ]}
                            className="dBlock"
                            initialValue={details?.units?.width}
                          >
                            <Select
                              placeholder="Unit"
                              suffixIcon={<DownArrowDraw />}
                              onChange={onChangeWidthUnit}
                              disabled={
                                props?.actionType == "view" ||
                                details?.progressbar_info?.completed?.weight >
                                  0 ||
                                details?.progressbar_info?.in_production
                                  ?.weight > 0
                              }
                            >
                              {dimesionUnitList.map((widthUnit) => (
                                <Option key={widthUnit} value={widthUnit}>
                                  {lengthUnit[widthUnit]?.displayName}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </div>
                      </Col>
                    </Row>
                  </div>
                )}

                {(props?.type == "orderRecord" ||
                  (props?.type == "deckleRecord" &&
                    props?.actionType == "view") ||
                  (props?.type == "approveOrder" &&
                    props?.actionType == "view")) &&
                  (orderTypes.length
                    ? (selectedType === "sheet" ||
                        orderTypes[0]?.value === "sheet") && (
                        <div className="drawerField">
                          <div className="titleWithText">
                            <h5>Grain</h5>
                            <p>The order can be of long or short grain</p>
                          </div>
                          <Form.Item
                            name="grain"
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                            ]}
                            className="selectForm"
                            style={{ marginBottom: 4 }}
                            initialValue={
                              details?.grain && details?.grain !== "null"
                                ? capitalize(details?.grain)
                                : ""
                            }
                          >
                            <Select
                              placeholder={"Select"}
                              suffixIcon={<DownArrowDraw />}
                              onChange={(e) => onGrainChange(e)}
                              disabled={props?.actionType == "view"}
                            >
                              {grainTypeData.map((grainType) => (
                                <Option key={grainType}>{grainType}</Option>
                              ))}
                            </Select>
                          </Form.Item>
                          <div className="italicsTitleWithText">
                            <p>
                              {grainValue === "Long Grain"
                                ? "The shorter side will be matched in deckle matching"
                                : grainValue === "Short Grain" &&
                                  "The longer side will be matched in deckle matching"}
                            </p>
                          </div>
                          <div>
                            <Row className="centerAlign justifyCSBetween">
                              <Col>
                                <Checkbox
                                  onChange={mixedGrainHandler}
                                  checked={mixedGrain}
                                  disabled={
                                    (props.isEditFromIncompleteOrder &&
                                      props.type === "deckleRecord") ||
                                    (props.isEditFromIncompleteOrder &&
                                      props.type === "orderRecord" &&
                                      !orderMangtSettings?.data
                                        ?.edit_after_approval?.value) ||
                                    props?.actionType == "view" ||
                                    details?.progressbar_info?.completed
                                      ?.weight > 0 ||
                                    details?.progressbar_info?.in_production
                                      ?.weight > 0
                                  }
                                ></Checkbox>
                                <span
                                  style={{
                                    marginLeft: "5px",
                                    fontSize: "12px",
                                    fontWeight: "500",
                                    fontSize: "12px",
                                    fontFamily: "var(--sf-pro-text)",
                                    color: "var(--color-text-title)",
                                    lineHeight: "20px",
                                  }}
                                >
                                  Allow mixed grain for this order
                                </span>
                              </Col>
                            </Row>
                          </div>
                          <div style={{ marginBottom: "10px" }}>
                            <Row className="centerAlign justifyCSBetween">
                              <Col>
                                <Checkbox
                                  onChange={grainChangesHandler}
                                  checked={grainChanges}
                                  disabled={
                                    (props.isEditFromIncompleteOrder &&
                                      props.type === "deckleRecord") ||
                                    (props.isEditFromIncompleteOrder &&
                                      props.type === "orderRecord" &&
                                      !orderMangtSettings?.data
                                        ?.edit_after_approval?.value) ||
                                    props?.actionType == "view" ||
                                    details?.progressbar_info?.completed
                                      ?.weight > 0 ||
                                    details?.progressbar_info?.in_production
                                      ?.weight > 0
                                  }
                                ></Checkbox>
                                <span
                                  style={{
                                    marginLeft: "5px",
                                    fontSize: "12px",
                                    fontWeight: "500",
                                    fontSize: "12px",
                                    fontFamily: "var(--sf-pro-text)",
                                    color: "var(--color-text-title)",
                                    lineHeight: "20px",
                                  }}
                                >
                                  Allow grain changes for this order
                                </span>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      )
                    : null)}

                {(props?.type == "orderRecord" ||
                  (props?.type == "deckleRecord" &&
                    props?.actionType == "view") ||
                  (props?.type == "approveOrder" &&
                    props?.actionType == "view")) && (
                  <div className="drawerField" style={{ paddingBottom: "2px" }}>
                    <div className="titleWithText">
                      <h5>Order Quantity</h5>
                      <p>Quantity of the order to be produced</p>
                    </div>
                    <div
                      className=" switchRadio twoSwitch"
                      style={{ justifyContent: "center", display: "flex" }}
                    >
                      <Radio.Group
                        options={orderQuantityTab}
                        optionType="button"
                        buttonStyle="solid"
                        value={orderQuantity}
                        disabled={
                          props?.actionType == "view" ||
                          details?.progressbar_info?.completed?.weight > 0 ||
                          details?.progressbar_info?.in_production?.weight > 0
                        }
                        onChange={handleQuantityChange}
                      />
                    </div>
                    {orderQuantity === "weight" ? (
                      <>
                        <div className="subTitleWithText">
                          <p></p>
                        </div>
                        <div style={{ position: "relative" }}>
                          <Row className="centerAlign justifyCSBetween">
                            <Col span={13}>
                              <div className="boxFormType">
                                <Form.Item
                                  name="weight"
                                  rules={[
                                    {
                                      required: true,
                                      message: "This field is required",
                                    },
                                    {
                                      pattern: new RegExp(/^\d+(\.\d+)?$/),
                                      message:
                                        "Only decimal characters are allowed",
                                    },
                                    {
                                      pattern: new RegExp(
                                        /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                                      ),
                                      message:
                                        "Weight should be a number greater than zero",
                                    },
                                  ]}
                                  className="dBlock"
                                  initialValue={parseFloat(
                                    details?.weight
                                  ).toFixed(3)}
                                >
                                  <Input
                                    placeholder="Enter weight"
                                    onChange={(e) => {
                                      handleWeight(e);
                                    }}
                                    // disabled={
                                    //   (props.isEditFromIncompleteOrder &&
                                    //     props.type === "deckleRecord") ||
                                    //   (props.isEditFromIncompleteOrder &&
                                    //     props.type === "orderRecord" &&
                                    //     !orderMangtSettings?.data
                                    //       ?.edit_after_approval?.value) ||
                                    //   props?.actionType == "view" ||
                                    //   details?.progressbar_info?.completed
                                    //     ?.weight > 0 ||
                                    //   details?.progressbar_info?.in_production
                                    //     ?.weight > 0
                                    // }
                                  />
                                </Form.Item>
                              </div>
                            </Col>
                            <Col span={10}>
                              <div className="boxFormType ">
                                <Form.Item
                                  name="weightUnit"
                                  rules={[
                                    {
                                      required: true,
                                      message: "This field is required",
                                    },
                                  ]}
                                  className="dBlock"
                                  initialValue={details?.units?.weight}
                                >
                                  <Select
                                    placeholder="Unit"
                                    suffixIcon={<DownArrowDraw />}
                                    onChange={onChangeWeightUnit}
                                    disabled={
                                      props?.actionType == "view" ||
                                      details?.progressbar_info?.completed
                                        ?.weight > 0 ||
                                      details?.progressbar_info?.in_production
                                        ?.weight > 0
                                    }
                                  >
                                    {weightUnitList?.map((unitItem) => (
                                      <Option key={unitItem} value={unitItem}>
                                        {weightUnit[unitItem]?.displayName}
                                      </Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </>
                    ) : orderQuantity === "reel" ? (
                      <>
                        <div className="subTitleWithText">
                          <p></p>
                        </div>
                        <Form.Item
                          name="quantity"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                            {
                              pattern: new RegExp(/^\d+(\.\d+)?$/),
                              message: "Only decimal characters are allowed",
                            },
                            {
                              pattern: new RegExp(
                                /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                              ),
                              message:
                                "Quantity should be a number greater than zero",
                            },
                          ]}
                          className=""
                          initialValue={details?.no_of_reel_sheet}
                        >
                          <Input
                            placeholder="Enter quantity"
                            onChange={(e) => {
                              onQuantityValueChange(e);
                            }}
                            disabled={
                              props?.actionType == "view" ||
                              details?.progressbar_info?.completed?.weight >
                                0 ||
                              details?.progressbar_info?.in_production?.weight >
                                0
                            }
                          />
                        </Form.Item>
                      </>
                    ) : (
                      <>
                        <div className="subTitleWithText">
                          <p></p>
                        </div>
                        <Form.Item
                          name="quantity"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                            {
                              pattern: new RegExp(/^\d+(\.\d+)?$/),
                              message: "Only decimal characters are allowed",
                            },
                            {
                              pattern: new RegExp(
                                /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                              ),
                              message:
                                "Quantity should be a number greater than zero",
                            },
                          ]}
                          className=""
                          initialValue={details?.no_of_reel_sheet}
                        >
                          <Input
                            placeholder="Enter quantity"
                            onChange={(e) => {
                              onQuantityValueChange(e);
                            }}
                            disabled={
                              props?.actionType == "view" ||
                              details?.progressbar_info?.completed?.weight >
                                0 ||
                              details?.progressbar_info?.in_production?.weight >
                                0
                            }
                          />
                        </Form.Item>
                      </>
                    )}
                    {orderQuantity === "weight" && isToleranceDisabled && (
                      <Collapse
                        onChange={onChangeCollpase}
                        expandIconPosition="right"
                        bordered={false}
                        style={{ backgroundColor: "white", marginTop: "-15px" }}
                      >
                        <Panel
                          header={
                            "Tolerance -" +
                            defaultLowerOrderTol+
                            " to +" +
                            defaultUpperOrderTol+
                            " %"
                          }
                          style={{ fontStyle: "italic", marginLeft: "-12px" }}
                        >
                          <Row
                            style={{ marginTop: "3px" }}
                            className="centerAlign  justifyCSBetween"
                          >
                            <Col span={8} className="blockBreak">
                              <div className="titleWithText">
                                <p
                                  style={{
                                    marginTop: "7px",
                                    fontStyle: "initial",
                                    fontSize: "12px",
                                    fontFamily: "var(--sf-pro-text)",
                                    color: "var(--color-text-title)",
                                    lineHeight: "20px",
                                  }}
                                >
                                  Upper Tolerance{" "}
                                </p>
                              </div>
                            </Col>
                            <Col span={8} className="blockBreak">
                              <div
                                className="boxFormType"
                                style={{ marginBottom: "0" }}
                              >
                                <Form.Item
                                  label=""
                                  name="order_upper_tolerance"
                                  rules={[
                                    {
                                      pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                      message: "Only Numeric value is possible",
                                    },
                                    {
                                      required: true,
                                      message: "This field is required",
                                    },
                                    {
                                      validator(_, value) {
                                        if (parseFloat(value) == 0) {
                                          return Promise.reject(
                                            "Min upper tolerance should be atleast 1 %"
                                          );
                                        } else {
                                          return Promise.resolve();
                                        }
                                      },
                                    },
                                  ]}
                                  className="dBlock"
                                >
                                  <Input
                                    placeholder=""
                                    style={{ fontSize: "10px", height: "30px" }}
                                    onChange={(e) => {
                                      onUpperTolChange(e, "order_tolerance");
                                    }}
                                    disabled={
                                      props?.actionType == "view" ||
                                      details?.progressbar_info?.completed
                                        ?.weight > 0 ||
                                      details?.progressbar_info?.in_production
                                        ?.weight > 0
                                    }
                                  />
                                </Form.Item>
                                <span
                                  className="nonEditable"
                                  style={{ fontSize: "13px", top: "6px" }}
                                >
                                  %
                                </span>
                              </div>
                            </Col>
                            <Col span={8} className="blockBreak">
                              <Col
                                span={8}
                                className="blockBreak"
                                style={{ maxWidth: "45%", marginLeft: "15px" }}
                              >
                                <div className="titleWithText">
                                  <p
                                    style={{
                                      fontSize: "12px",
                                      fontFamily: "var(--sf-pro-text)",
                                      color: "var(--color-text-title)",
                                      lineHeight: "20px",
                                      marginTop: "7px",
                                      fontStyle: "initial",
                                      width: "104px",
                                    }}
                                  >
                                    {parseFloat(orderUpperTol)?.toFixed(3) +
                                      " "}{" "}
                                    {weightUnit[unitPlaceholder]?.displayName}
                                  </p>
                                </div>
                              </Col>
                            </Col>
                          </Row>

                          <Row
                            style={{ marginTop: "0px" }}
                            className="centerAlign  justifyCSBetween"
                          >
                            <Col span={8} className="blockBreak">
                              <div className="titleWithText">
                                <p
                                  style={{
                                    marginTop: "7px",
                                    fontStyle: "initial",
                                    fontSize: "12px",
                                    fontFamily: "var(--sf-pro-text)",
                                    color: "var(--color-text-title)",
                                    lineHeight: "20px",
                                  }}
                                >
                                  Lower Tolerance{" "}
                                </p>
                              </div>
                            </Col>
                            <Col span={8} className="blockBreak">
                              <div
                                className="boxFormType"
                                style={{ marginBottom: "0" }}
                              >
                                <Form.Item
                                  label=""
                                  name="order_lower_tolerance"
                                  rules={[
                                    {
                                      pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                      message: "Only Numeric value is possible",
                                    },
                                    {
                                      required: true,
                                      message: "This field is required",
                                    },
                                    {
                                      validator(_, value) {
                                        if (parseFloat(value) == 0) {
                                          return Promise.reject(
                                            "Min lower tolerance should be atleast 1 %"
                                          );
                                        } else {
                                          return Promise.resolve();
                                        }
                                      },
                                    },
                                  ]}
                                  className="dBlock"
                                >
                                  <Input
                                    placeholder=""
                                    style={{ fontSize: "10px", height: "30px" }}
                                    onChange={(e) => {
                                      onLowerTolChange(e, "order_tolerance");
                                    }}
                                    disabled={
                                      props?.actionType == "view" ||
                                      details?.progressbar_info?.completed
                                        ?.weight > 0 ||
                                      details?.progressbar_info?.in_production
                                        ?.weight > 0
                                    }
                                  />
                                </Form.Item>
                                <span
                                  className="nonEditable"
                                  style={{ fontSize: "13px", top: "6px" }}
                                >
                                  %
                                </span>
                              </div>
                            </Col>
                            <Col span={8} className="blockBreak">
                              <Col
                                span={8}
                                className="blockBreak"
                                style={{ maxWidth: "45%", marginLeft: "15px" }}
                              >
                                <div className="titleWithText">
                                  <p
                                    style={{
                                      fontSize: "12px",
                                      fontFamily: "var(--sf-pro-text)",
                                      color: "var(--color-text-title)",
                                      lineHeight: "20px",
                                      marginTop: "7px",
                                      fontStyle: "initial",
                                      width: "104px",
                                    }}
                                  >
                                    {parseFloat(orderLowerTol)?.toFixed(3) +
                                      " "}{" "}
                                    {weightUnit[unitPlaceholder]?.displayName}
                                  </p>
                                </div>
                              </Col>
                            </Col>
                          </Row>
                        </Panel>
                      </Collapse>
                    )}
                  </div>
                )}

                  {orderMangtSettings?.data?.fetch_balance_quantity?.value ?
                    (
                      <div className="drawerField" style={{ paddingBottom: "2px" }}>
                        <div className="titleWithText">
                          <h5>Balance Quantity</h5>
                          <p>Balance order quantity to be produced</p>
                        </div>
                        <>
                          <div className="subTitleWithText">
                            <p></p>
                          </div>
                          <div style={{ position: "relative" }}>
                            <Row className="centerAlign justifyCSBetween">
                              <Col span={13}>
                                <div className="boxFormType">
                                  <Form.Item
                                    name="balance_qty"
                                    rules={[
                                      {
                                        required: true,
                                        message: "This field is required",
                                      },
                                      {
                                        pattern: new RegExp(/^\d+(\.\d+)?$/),
                                        message:
                                          "Only decimal characters are allowed",
                                      },
                                      // {
                                      //   pattern: new RegExp(
                                      //     /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                                      //   ),
                                      //   message:
                                      //     "Balance Quantity should be a number greater than zero",
                                      // },
                                    ]}
                                    className="dBlock"
                                    initialValue={details?.balance_weight}
                                  >
                                    <Input
                                      placeholder="Enter Balance Quantity"
                                      onChange={(e) => {
                                        handleBalanceQty(e);
                                      }}
                                      disabled={
                                        (props.isEditFromIncompleteOrder &&
                                          props.type === "deckleRecord") ||
                                        (props.isEditFromIncompleteOrder &&
                                          props.type === "orderRecord" &&
                                          !orderMangtSettings?.data
                                            ?.edit_after_approval?.value) ||
                                        props?.actionType == "view" ||
                                        details?.progressbar_info?.completed
                                          ?.weight > 0 ||
                                        details?.progressbar_info?.in_production
                                          ?.weight > 0
                                      }
                                    />
                                  </Form.Item>
                                </div>
                              </Col>
                              <Col span={10}>
                                <div className="boxFormType ">
                                  <Form.Item
                                    name="balanceQtyUnit"
                                    rules={[
                                      {
                                        required: true,
                                        message: "This field is required",
                                      },
                                    ]}
                                    className="dBlock"
                                    initialValue={details?.units?.weight}
                                  >
                                    <Select
                                      placeholder="Unit"
                                      suffixIcon={<DownArrowDraw />}
                                      onChange={onChangeBalanceUnit}
                                      disabled
                                    >
                                      {weightUnitList?.map((unitItem) => (
                                        <Option key={unitItem} value={unitItem}>
                                          {weightUnit[unitItem]?.displayName}
                                        </Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                </div>
                              </Col>
                              {balanceQtyErr ? (
                                <span
                                  className="errorText"
                                  style={{
                                    color: "#ea4e2c",
                                    marginTop: "-17px",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Balance quantity cannot be greater than weight
                                </span>
                              ) : null}
                            </Row>
                          </div>
                        </>
                      </div>
                    )
                    : (
                      <></>
                    )
                  }

                  <div className="drawerField" style={{ paddingBottom: "2px" }}>
                    <div className="titleWithText">
                      <h5>Order status</h5>
                      <p>Pending orders will be available for deckle plan</p>
                    </div>
                    <Form.Item
                      name="order_status"
                      rules={[
                        {
                          required: true,
                          message: "This field is required",
                        },
                      ]}
                      className="selectForm"
                      initialValue={(details?.state == "approved" || details?.state == "complete") ? details?.state : 
                        allStateData[details?.state] }
                    >
                      {(details?.state == "approved" || details?.state == "complete") ? (
                        <Select
                        placeholder="Select Status"
                        suffixIcon={<DownArrowDraw />}
                        showSearch
                        optionFilterProp="children"
                        // disabled={
                        //   props?.actionType == "view"
                        // }
                        disabled
                        // onChange={handlePlyChange}
                      >
                        {stateData.map((item) => (
                          <Option key={item.key} value={item.key}>{item.value}</Option>
                        ))}
                      </Select>) : (
                        <Input
                            // style={{ width: "185px" }}
                            disabled
                          />
                      )}
                    </Form.Item>
                  </div>

                {props.category==='po'?(
                  <>
                {(props?.type == "orderRecord" ||
                  (props?.type == "deckleRecord" &&
                    props?.actionType == "view") ||
                  (props?.type == "approveOrder" &&
                    props?.actionType == "view")) && (
                  <div className="drawerField removeStar">
                    <div className="titleWithText">
                      <h5>Price Details</h5>
                      <p>Quoted Price of the order</p>
                    </div>
                    <div
                      className="titleWithText"
                      style={{ marginTop: "-6px" }}
                    >
                      <p>
                        Product Price:{" "}
                        {productData?.price && (
                          <span>
                            {productData?.symbol}{" "}
                            {parseFloat(productData?.price)?.toFixed(3)}
                            {" / "}
                            {productData?.units?.per_weight_unit
                              ? capitalize(
                                  weightUnit[productData.units.per_weight_unit]
                                    ?.displayName
                                )
                              : "T"}
                          </span>
                        )}
                      </p>
                    </div>
                    <Row className="centerAlign  justifyCSBetween">
                      <Col style={{ paddingRight: "5px" }} span={9}>
                        <div
                          className="boxFormType"
                          style={{ marginBottom: "0" }}
                        >
                          <Form.Item
                            label={
                              "Dealer Price" +
                              (priceUnit
                                ? " / " + weightUnit[priceUnit]?.displayName
                                : "")
                            }
                            name="dealer_price"
                            rules={[
                              {
                                pattern: new RegExp(/^\d+(\.\d+)?$/),
                                message: "Only decimal values possible",
                              },
                            ]}
                            className="dBlock"
                            initialValue={details?.dealer_price}
                          >
                            <Input
                              placeholder="Dealer Price"
                              onChange={handleDealerPrice}
                              disabled={
                                (props.isEditFromIncompleteOrder &&
                                  props.type === "deckleRecord") ||
                                (props.isEditFromIncompleteOrder &&
                                  props.type === "orderRecord" &&
                                  !orderMangtSettings?.data?.edit_after_approval
                                    ?.value) ||
                                props?.actionType == "view" ||
                                details?.progressbar_info?.completed?.weight >
                                  0 ||
                                details?.progressbar_info?.in_production
                                  ?.weight > 0
                              }
                            />
                          </Form.Item>
                        </div>
                      </Col>
                      <Col style={{ paddingRight: "5px" }} span={9}>
                        <div
                          className="boxFormType"
                          style={{ marginBottom: "0" }}
                        >
                          <Form.Item
                            label={
                              "Customer Price" +
                              (priceUnit
                                ? " / " + weightUnit[priceUnit]?.displayName
                                : "")
                            }
                            name="customer_price"
                            rules={[
                              {
                                pattern: new RegExp(/^\d+(\.\d+)?$/),
                                message: "Only decimal values possible",
                              },
                            ]}
                            className="dBlock"
                            initialValue={details?.customer_price}
                          >
                            <Input
                              placeholder="Customer Price"
                              disabled={
                                (props.isEditFromIncompleteOrder &&
                                  props.type === "deckleRecord") ||
                                (props.isEditFromIncompleteOrder &&
                                  props.type === "orderRecord" &&
                                  !orderMangtSettings?.data?.edit_after_approval
                                    ?.value) ||
                                props?.actionType == "view" ||
                                details?.progressbar_info?.completed?.weight >
                                  0 ||
                                details?.progressbar_info?.in_production
                                  ?.weight > 0
                              }
                            />
                          </Form.Item>
                        </div>
                      </Col>
                      <Col span={6}>
                        <div className="boxFormType unitSelect">
                          <Form.Item
                            label="Currency"
                            name="currency"
                            rules={[{}]}
                            className="dBlock"
                            initialValue={details?.units?.net_price}
                          >
                            <Select
                              placeholder="Currency"
                              suffixIcon={<DownArrowDraw />}
                              showSearch
                              optionFilterProp="children"
                              onChange={(e) => {
                                onCurrencyChange(e);
                              }}
                              disabled={
                                (props.isEditFromIncompleteOrder &&
                                  props.type === "deckleRecord") ||
                                (props.isEditFromIncompleteOrder &&
                                  props.type === "orderRecord" &&
                                  !orderMangtSettings?.data?.edit_after_approval
                                    ?.value) ||
                                props?.actionType == "view" ||
                                details?.progressbar_info?.completed?.weight >
                                  0 ||
                                details?.progressbar_info?.in_production
                                  ?.weight > 0
                              }
                            >
                              {currencyUnitData.map((currencyUnit) => (
                                <Option
                                  key={currencyUnit.code}
                                  value={currencyUnit.code}
                                >
                                  <Tooltip title={currencyUnit.displayName}>
                                    {`${currencyUnit.code}`}
                                  </Tooltip>
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </div>
                      </Col>
                    </Row>
                    {orderQuantity !== "reel" && (
                      <div
                        className="titleWithText"
                        style={{ marginTop: "-5px" }}
                      >
                        <p>
                          Net Price:{" "}
                          {netPrice ? netPriceSymbol + " " + netPrice : ""}
                          {/* ? (netPriceSymbol + " " + netPrice +
                            (priceUnit ? (" / " + capitalize(weightUnit[priceUnit]?.displayName)) : "")) : ""} */}
                        </p>
                      </div>
                    )}
                  </div>
                )}

                {(props?.type == "orderRecord" ||
                  (props?.type == "deckleRecord" &&
                    props?.actionType == "view") ||
                  (props?.type == "approveOrder" &&
                    props?.actionType == "view")) && (
                  <div className="drawerField">
                    <div className="titleWithText">
                      <h5>Delivery Date</h5>
                      <p>Date when this quantity should be delivered</p>
                    </div>
                    <div className="boxFormType">
                      <DatePickerY>
                        <Form.Item
                          name="delivery_date"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                          ]}
                          initialValue={moment(
                            details?.delivery_date,
                            "DD MM YYYY"
                          )}
                        >
                          <DatePicker
                            format={"DD/MM/YYYY"}
                            disabledDate={(current) => {
                              return (
                                current && current < moment().subtract(1, "day")
                              );
                            }}
                            disabled={
                              props?.actionType == "view" ||
                              details?.progressbar_info?.completed?.weight >
                                0 ||
                              details?.progressbar_info?.in_production?.weight >
                                0
                            }
                          />
                        </Form.Item>
                      </DatePickerY>
                    </div>
                  </div>
                )}

                {(props?.type == "orderRecord" ||
                  (props?.type == "deckleRecord" &&
                    props?.actionType == "view") ||
                  (props?.type == "approveOrder" &&
                    props?.actionType == "view")) && (
                  <div
                    className="drawerField"
                    style={{ paddingBottom: "20px" }}
                  >
                    <Collapse
                      onChange={onChangeCollpase}
                      expandIconPosition="right"
                      bordered={false}
                      style={{
                        backgroundColor: "white",
                        marginTop: "-12px",
                        marginBottom: "-20px",
                      }}
                      className="deliAddCollapseIcon"
                    >
                      <Panel
                        header={
                          <div style={{ marginLeft: "-12px" }}>
                            <div className="titleWithText">
                              <h5>Delivery Address</h5>
                              <p style={{ width: "max-content" }}>
                                The postal address where order needs to be
                                delivered
                              </p>
                            </div>
                            <GlobalSet>
                              <div className="checklist-address">
                                <Checkbox
                                  type="checkbox"
                                  checked={checkedBox}
                                  onChange={onChangeHandlerBox}
                                  disabled={
                                    (props.isEditFromIncompleteOrder &&
                                      props.type === "deckleRecord") ||
                                    (props.isEditFromIncompleteOrder &&
                                      props.type === "orderRecord" &&
                                      !orderMangtSettings?.data
                                        ?.edit_after_approval?.value) ||
                                    props.actionType == "view"
                                  }
                                />
                                <p
                                  style={{
                                    fontSize: 14,
                                    fontWeight: 100,
                                  }}
                                >
                                  The order address is same as the PO address
                                </p>
                              </div>
                            </GlobalSet>
                          </div>
                        }
                      >
                        <Col span={24}>
                          <Row className="centerAlign">
                            <DeliveryaddressSpacing>
                              <Col
                                span={24}
                                className="blockBreak haberdeliveryaddress"
                              >
                                <div className="boxFormType">
                                  <DisabledStyles>
                                    <Form.Item
                                      name="delivery_address_line_1"
                                      initialValue={
                                        details?.delivery_address_line_1
                                      }
                                      rules={[
                                        {
                                          required: checkedBox ? false : true,
                                          message: "This field is required",
                                        },
                                        {
                                          max: 50,
                                          message: "Maximum length: 50",
                                        },
                                      ]}
                                      className=""
                                    >
                                      <Input
                                        disabled={
                                          checkedBox ||
                                          (props.isEditFromIncompleteOrder &&
                                            props.type === "deckleRecord") ||
                                          (props.isEditFromIncompleteOrder &&
                                            props.type === "orderRecord" &&
                                            !orderMangtSettings?.data
                                              ?.edit_after_approval?.value) ||
                                          props?.actionType == "view"
                                        }
                                        className="disabled-check"
                                        placeholder="First Line of address"
                                      />
                                    </Form.Item>
                                  </DisabledStyles>
                                </div>
                                <div className="boxFormType">
                                  <DisabledStyles>
                                    <Form.Item
                                      name="delivery_address_line_2"
                                      initialValue={
                                        details?.delivery_address_line_2
                                      }
                                      rules={[
                                        {
                                          max: 50,
                                          message: "Maximum length: 50",
                                        },
                                      ]}
                                      className=""
                                    >
                                      <Input
                                        disabled={
                                          checkedBox ||
                                          (props.isEditFromIncompleteOrder &&
                                            props.type === "deckleRecord") ||
                                          (props.isEditFromIncompleteOrder &&
                                            props.type === "orderRecord" &&
                                            !orderMangtSettings?.data
                                              ?.edit_after_approval?.value) ||
                                          props?.actionType == "view"
                                        }
                                        className="disabled-check"
                                        placeholder="Second Line of address"
                                      />
                                    </Form.Item>
                                  </DisabledStyles>
                                </div>
                                <Col span={12} className="d-flex">
                                  <div className="boxFormType">
                                    <DisabledStyles>
                                      <Form.Item
                                        name="delivery_country"
                                        initialValue={details?.delivery_country}
                                        rules={[
                                          {
                                            required: checkedBox ? false : true,
                                            message: "This field is required",
                                          },
                                        ]}
                                        className=""
                                      >
                                        <Select
                                          disabled={
                                            checkedBox ||
                                            (props.isEditFromIncompleteOrder &&
                                              props.type === "deckleRecord") ||
                                            (props.isEditFromIncompleteOrder &&
                                              props.type === "orderRecord" &&
                                              !orderMangtSettings?.data
                                                ?.edit_after_approval?.value) ||
                                            props?.actionType == "view"
                                          }
                                          className="disabled-check"
                                          suffixIcon={<DownArrowDraw />}
                                          showSearch
                                          optionFilterProp="children"
                                          filterOption={(input, option) =>
                                            option.children
                                              .toLowerCase()
                                              .includes(input.toLowerCase())
                                          }
                                          onChange={handleProvinceChange}
                                          placeholder="Country"
                                        >
                                          {Country.getAllCountries().map(
                                            (province) => (
                                              <Option key={province.isoCode}>
                                                {province.name}
                                              </Option>
                                            )
                                          )}
                                        </Select>
                                      </Form.Item>
                                    </DisabledStyles>
                                  </div>
                                  <div className="boxFormType">
                                    <DisabledStyles>
                                      <Form.Item
                                        name="delivery_state"
                                        initialValue={details?.delivery_state}
                                        rules={[
                                          {
                                            required: checkedBox ? false : true,
                                            message: "This field is required",
                                          },
                                        ]}
                                        className=""
                                      >
                                        <Select
                                          disabled={
                                            checkedBox ||
                                            (props.isEditFromIncompleteOrder &&
                                              props.type === "deckleRecord") ||
                                            (props.isEditFromIncompleteOrder &&
                                              props.type === "orderRecord" &&
                                              !orderMangtSettings?.data
                                                ?.edit_after_approval?.value) ||
                                            props?.actionType == "view"
                                          }
                                          suffixIcon={<DownArrowDraw />}
                                          showSearch
                                          optionFilterProp="children"
                                          filterOption={(input, option) =>
                                            option.children
                                              .toLowerCase()
                                              .includes(input.toLowerCase())
                                          }
                                          placeholder="State"
                                        >
                                          {cities.map((city) => (
                                            <Option key={city.name}>
                                              {city.name}
                                            </Option>
                                          ))}
                                        </Select>
                                      </Form.Item>
                                    </DisabledStyles>
                                  </div>
                                </Col>
                                <Col span={12} className="d-flex">
                                  <div
                                    className="boxFormType"
                                    style={{ marginBottom: "0" }}
                                  >
                                    <DisabledStyles>
                                      <Form.Item
                                        name="delivery_city"
                                        initialValue={details?.delivery_city}
                                        rules={[
                                          {
                                            required: checkedBox ? false : true,
                                            message: "This field is required",
                                          },
                                          {
                                            max: 50,
                                            message: "Maximum length: 50",
                                          },
                                        ]}
                                        className=""
                                      >
                                        <Input
                                          style={{
                                            textTransform: "capitalize",
                                          }}
                                          placeholder="City"
                                          disabled={
                                            checkedBox ||
                                            (props.isEditFromIncompleteOrder &&
                                              props.type === "deckleRecord") ||
                                            (props.isEditFromIncompleteOrder &&
                                              props.type === "orderRecord" &&
                                              !orderMangtSettings?.data
                                                ?.edit_after_approval?.value) ||
                                            props?.actionType == "view"
                                          }
                                          className="disabled-check"
                                        />
                                      </Form.Item>
                                    </DisabledStyles>
                                  </div>
                                  <div className="boxFormType">
                                    <DisabledStyles>
                                      <Form.Item
                                        name="zip_code"
                                        initialValue={details?.delivery_pincode}
                                        rules={[
                                          {
                                            required: checkedBox ? false : true,
                                            message: "This field is required",
                                          },
                                          {
                                            min: 6,
                                            message: "Minimum length: 6",
                                          },
                                          {
                                            max: 6,
                                            message: "Maximum length: 6",
                                          },
                                          {
                                            pattern: new RegExp(/^[0-9]+$/),
                                            message:
                                              "Only Numeric value is possible",
                                          },
                                        ]}
                                        className=""
                                      >
                                        <Input
                                          disabled={
                                            checkedBox ||
                                            (props.isEditFromIncompleteOrder &&
                                              props.type === "deckleRecord") ||
                                            (props.isEditFromIncompleteOrder &&
                                              props.type === "orderRecord" &&
                                              !orderMangtSettings?.data
                                                ?.edit_after_approval?.value) ||
                                            props?.actionType == "view"
                                          }
                                          className="disabled-check"
                                          placeholder="ZIP code"
                                        />
                                      </Form.Item>
                                    </DisabledStyles>
                                  </div>
                                </Col>
                              </Col>
                            </DeliveryaddressSpacing>
                          </Row>
                        </Col>
                      </Panel>
                    </Collapse>
                  </div>
                )}
                </>
              ):<></>}
                

                {(props?.type == "orderRecord" ||
                  (props?.type == "deckleRecord" &&
                    props?.actionType == "view") ||
                  (props?.type == "approveOrder" &&
                    props?.actionType == "view")) && (
                  <div className="drawerField">
                    <div className="titleWithText">
                      <h5>Packaging Details</h5>
                      <p>
                        Type of packaging to be used for this item in shipping
                      </p>
                    </div>
                    <Form.Item
                      name="packaging_name"
                      className="selectForm"
                      // initialValue={
                      //   details?.packaging_details?.name + " - " + " " +
                      //   (details?.packaging_details?.quantity_type === "weight"
                      //     ? ((details?.packaging_details?.weight ? details?.packaging_details?.weight?.toFixed(3) : "") +
                      //       " " +
                      //       (details?.packaging_details?.units && details?.packaging_details?.units?.weight
                      //         ? capitalize(
                      //             weightUnit[details?.packaging_details?.units?.weight]?.displayName
                      //           )
                      //         : ""))
                      //     : (details?.packaging_details?.quantity +
                      //       " " +
                      //       capitalize(details?.packaging_details?.type) +
                      //       "s"))}
                      initialValue={details?.packaging_details?.id?.toString()}
                    >
                      <Select
                        placeholder="Select Packaging"
                        suffixIcon={<DownArrowDraw />}
                        showSearch
                        optionFilterProp="children"
                        onChange={(e) => {
                          handlePackaging(e);
                        }}
                        disabled={
                          (props.isEditFromIncompleteOrder &&
                            props.type === "deckleRecord") ||
                          (props.isEditFromIncompleteOrder &&
                            props.type === "orderRecord" &&
                            !orderMangtSettings?.data?.edit_after_approval
                              ?.value) ||
                          props?.actionType == "view" ||
                          details?.progressbar_info?.completed?.weight > 0 ||
                          details?.progressbar_info?.in_production?.weight > 0
                        }
                      >
                        {packagingData.length &&
                          packagingData?.map((item) => (
                            <Option key={item.id}>
                              {item.name} -{" "}
                              {item.quantity_type === "weight"
                                ? item.weight +
                                  " " +
                                  (item.units && item.units.weight
                                    ? capitalize(
                                        weightUnit[item.units.weight]
                                          ?.displayName
                                      )
                                    : "")
                                : item.quantity +
                                  " " +
                                  capitalize(item.type) +
                                  "s"}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </div>
                )}

                {(props?.type == "orderRecord" ||
                  (props?.type == "deckleRecord" &&
                    props?.actionType == "view") ||
                  (props?.type == "approveOrder" &&
                    props?.actionType == "view")) && (
                  <div className="drawerField">
                    <div className="titleWithText">
                      <h5>Remarks</h5>
                      <p>Any other Information related to the order</p>
                    </div>
                    <Form.Item
                      name="remarks"
                      className=""
                      initialValue={details?.remarks}
                    >
                      <TextArea
                        maxLength={100}
                        style={{ height: 90 }}
                        placeholder="Add Remarks"
                        disabled={
                          props?.actionType == "view" ||
                          details?.progressbar_info?.completed?.weight > 0 ||
                          details?.progressbar_info?.in_production?.weight > 0
                        }
                      />
                    </Form.Item>
                  </div>
                )}

                {(props?.type == "orderRecord" ||
                  (props?.type == "deckleRecord" &&
                    props?.actionType == "view") ||
                  (props?.type == "approveOrder" &&
                    props?.actionType == "view")) && (
                  <div className="drawerField">
                    <Collapse
                      onChange={onChangeCollpase}
                      expandIconPosition="right"
                      bordered={false}
                      style={{
                        backgroundColor: "white",
                        marginTop: "-12px",
                        marginBottom: "-20px",
                      }}
                      className="planningDetailsCollapseIcon"
                    >
                      <Panel
                        header={
                          <div style={{ marginLeft: "-12px" }}>
                            <div className="titleWithText">
                              <h5>Planning Details</h5>
                              <p>
                                Quantity pending to be processed and associated
                                rewinder details for the quantity
                              </p>
                            </div>
                          </div>
                        }
                      >
                        <div className="titleWithText">
                          <p
                            style={{ marginLeft: "-12px", marginTop: "-10px" }}
                          >
                            Pending Quantity:{" "}
                            {/* {(orderQuantity === "weight" || orderQuantity == "sheet") ? 
                          (details?.total_pending_quantity?.weight ? (details?.total_pending_quantity?.weight + " " + (details?.total_pending_quantity?.units?.weight ? capitalize(weightUnit[details?.total_pending_quantity?.units?.weight]?.displayName) : "")) : "")
                            : (details?.total_pending_quantity?.quantity ? (details?.total_pending_quantity?.quantity + " " + capitalize(orderQuantity) + "s") : "")} */}
                            {orderQuantity === "weight"
                              ? pendingQuantity || pendingQuantity == 0
                                ? pendingQuantity +
                                  " " +
                                  (unitPlaceholder
                                    ? capitalize(
                                        weightUnit[unitPlaceholder]?.displayName
                                      )
                                    : "")
                                : ""
                              : orderQuantity == "sheet"
                              ? pendingQuantity +
                                " (" +
                                pendingQntWeight +
                                (unitPlaceholder
                                  ? capitalize(
                                      weightUnit[unitPlaceholder]?.displayName
                                    )
                                  : "") +
                                ")"
                              : pendingQuantity || pendingQuantity == 0
                              ? pendingQuantity +
                                " " +
                                capitalize(orderQuantity) +
                                "s"
                              : ""}
                          </p>
                        </div>

                        <div
                          className="drawerField"
                          style={{ marginLeft: "-12px", marginTop: "-19px" }}
                        >
                          <div className="titleWithText">
                            <h5>Quantity to be planned</h5>
                            <p>Quantity of the order to be planned</p>
                          </div>
                          <div
                            className=" switchRadio twoSwitch"
                            style={{
                              justifyContent: "center",
                              display: "flex",
                              marginRight: "-8px",
                            }}
                          >
                            <Radio.Group
                              options={orderQuantityTab}
                              optionType="button"
                              buttonStyle="solid"
                              value={orderQuantity}
                              disabled={true}
                            />
                          </div>
                          {orderQuantity === "weight" ? (
                            <>
                              <div className="subTitleWithText">
                                <p></p>
                              </div>
                              <div style={{ position: "relative" }}>
                                <Row className="centerAlign justifyCSBetween">
                                  <Col span={13}>
                                    <div className="boxFormType">
                                      <Form.Item
                                        name="planning_weight"
                                        rules={[
                                          {
                                            required: true,
                                            message: "This field is required",
                                          },
                                          {
                                            pattern: new RegExp(
                                              /^\d+(\.\d{0,3})?$/
                                            ),
                                            message:
                                              "This value should be a non-zero positive value",
                                          },
                                          {
                                            pattern: new RegExp(
                                              /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                                            ),
                                            message:
                                              "Weight should be a number greater than zero",
                                          },
                                          // ({ getFieldValue }) => ({
                                          //   validator(_, value) {
                                          //     if (
                                          //       !value ||
                                          //       !getFieldValue("planned_weight")
                                          //     ) {
                                          //       return Promise.resolve();
                                          //     }
                                          //     if (
                                          //       parseFloat(value) >
                                          //       parseFloat(
                                          //         getFieldValue("planned_weight")
                                          //       )
                                          //     ) {
                                          //       return Promise.reject(
                                          //         new Error(
                                          //           "Planning weight cannot be greater than Planned Weight"
                                          //         )
                                          //       );
                                          //     }
                                          //     return Promise.resolve();
                                          //   },
                                          // }),
                                        ]}
                                        className="dBlock"
                                        initialValue={details?.planning_weight}
                                      >
                                        <Input
                                          style={{ width: "185px" }}
                                          placeholder="Enter weight"
                                          onChange={(e) => {
                                            handlePlanningWeight(e);
                                          }}
                                          disabled={
                                            // (props.isEditFromIncompleteOrder && props.type === "deckleRecord") ||
                                            (props.isEditFromIncompleteOrder &&
                                              props.type === "orderRecord" &&
                                              !orderMangtSettings?.data
                                                ?.edit_after_approval?.value) ||
                                            props?.actionType == "view"
                                          }
                                        />
                                      </Form.Item>
                                    </div>
                                  </Col>
                                  <Col span={10}>
                                    <div
                                      className="boxFormType"
                                      style={{ marginLeft: "10px" }}
                                    >
                                      <Form.Item
                                        name="planning_weightUnit"
                                        rules={[
                                          {
                                            required: true,
                                            message: "This field is required",
                                          },
                                        ]}
                                        className="dBlock"
                                        initialValue={unitPlaceholder}
                                      >
                                        <Select
                                          placeholder="Unit"
                                          suffixIcon={<DownArrowDraw />}
                                          disabled={true}
                                        >
                                          {weightUnitList?.map((unitItem) => (
                                            <Option
                                              key={unitItem}
                                              value={unitItem}
                                            >
                                              {
                                                weightUnit[unitItem]
                                                  ?.displayName
                                              }
                                            </Option>
                                          ))}
                                        </Select>
                                      </Form.Item>
                                    </div>
                                  </Col>
                                  {planningWtErr ? (
                                    <span
                                      className="errorText"
                                      style={{
                                        color: "#ea4e2c",
                                        marginTop: "-17px",
                                        marginBottom: "5px",
                                      }}
                                    >
                                      Quantity to be planned cannot be more than
                                      the pending quantity
                                    </span>
                                  ) : null}
                                </Row>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="subTitleWithText">
                                <p></p>
                              </div>
                              <div style={{ position: "relative" }}>
                                <Form.Item
                                  name="planning_quantity"
                                  rules={[
                                    {
                                      required: true,
                                      message: "This field is required",
                                    },
                                    {
                                      pattern: new RegExp(/^\d+(\.\d+)?$/),
                                      message:
                                        "This value should be a non-zero positive value",
                                    },
                                    {
                                      pattern: new RegExp(
                                        /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                                      ),
                                      message:
                                        "Quantity should be a number greater than zero",
                                    },
                                  ]}
                                  className=""
                                  initialValue={details?.planning_quantity}
                                >
                                  <Input
                                    style={{ width: "332px" }}
                                    placeholder="Enter quantity"
                                    onChange={(e) => {
                                      onPlanningQuantityValueChange(e);
                                    }}
                                    disabled={
                                      // (props.isEditFromIncompleteOrder && props.type === "deckleRecord") ||
                                      (props.isEditFromIncompleteOrder &&
                                        !orderMangtSettings?.data
                                          ?.edit_after_approval?.value) ||
                                      props?.actionType == "view"
                                    }
                                  />
                                </Form.Item>
                                {planningWtErr ? (
                                  <div
                                    className="errorText"
                                    style={{
                                      color: "#ea4e2c",
                                      marginTop: "-17px",
                                      marginBottom: "5px",
                                    }}
                                  >
                                    Quantity to be planned cannot be more than
                                    the pending quantity
                                  </div>
                                ) : null}
                              </div>
                            </>
                          )}
                        </div>

                        <div
                          className="drawerField"
                          style={{
                            borderBottom: "0px solid #edebe9",
                            marginLeft: "-12px",
                          }}
                        >
                          <div className="titleWithText">
                            <h5>Rewinder Details</h5>
                            <p>
                              The outer diameter of the reel and rewinder core
                            </p>
                          </div>

                          <div className="titleWithText">
                            <p
                              style={{ marginLeft: "3px", marginBottom: "4px" }}
                            >
                              Core OD
                            </p>
                          </div>
                          <Form.Item
                            name="core_OD"
                            rules={[]}
                            className="selectForm"
                          >
                            <Select
                              placeholder="Select Core OD"
                              suffixIcon={<DownArrowDraw />}
                              showSearch
                              optionFilterProp="children"
                              onChange={handleCoreOD}
                              style={{ width: "331px" }}
                              disabled={
                                // (props.isEditFromIncompleteOrder && props.type === "deckleRecord") ||
                                // (props.isEditFromIncompleteOrder && !orderMangtSettings?.data?.edit_after_approval?.value)
                                props?.actionType == "view"
                              }
                            >
                              {coreValues?.map((data) => (
                                <Option key={data.value}>{data.value}</Option>
                              ))}
                            </Select>
                          </Form.Item>
                          {coreOdValidationError ? (
                            <div
                              className="errorText"
                              style={{
                                color: "#ea4e2c",
                                marginLeft: "2px",
                                marginTop: "-22px",
                                marginBottom: "20px",
                              }}
                            >
                              Reel OD cannot be less than Core OD
                            </div>
                          ) : null}
                          <div
                            className=" switchRadio twoSwitch"
                            style={{
                              justifyContent: "center",
                              display: "flex",
                              marginRight: "-8px",
                            }}
                          >
                            <Radio.Group
                              options={rewinderType}
                              optionType="button"
                              buttonStyle="solid"
                              value={outerDiameter}
                              disabled={
                                (selectedType == "reel" &&
                                  orderQuantity == "reel") ||
                                // (props.isEditFromIncompleteOrder && props.type === "deckleRecord") ||
                                (props.isEditFromIncompleteOrder &&
                                  !orderMangtSettings?.data?.edit_after_approval
                                    ?.value) ||
                                props?.actionType == "view"
                              }
                              onChange={handleRewinderType}
                            />
                          </div>
                          {outerDiameter === "constant" ? (
                            selectedType == "reel" &&
                            orderQuantity == "reel" ? (
                              <div className="titleWithText">
                                <p
                                  style={{
                                    marginLeft: "3px",
                                    marginBottom: "4px",
                                    marginTop: "22px",
                                  }}
                                >
                                  Reel OD
                                </p>
                                <Form.Item
                                  name="reel_OD"
                                  rules={[]}
                                  className="selectForm"
                                >
                                  <Select
                                    placeholder="Select Reel OD"
                                    suffixIcon={<DownArrowDraw />}
                                    showSearch
                                    optionFilterProp="children"
                                    onChange={handleReelOD}
                                    style={{ width: "331px" }}
                                    disabled={
                                      // (props.isEditFromIncompleteOrder && props.type === "deckleRecord") ||
                                      // (props.isEditFromIncompleteOrder && !orderMangtSettings?.data?.edit_after_approval?.value)
                                      props?.actionType == "view"
                                    }
                                  >
                                    {reelValues?.map((data) => (
                                      <Option key={data.value}>
                                        {data.value}
                                      </Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                              </div>
                            ) : (
                              <div>
                                <p
                                  style={{
                                    marginLeft: "3px",
                                    marginBottom: "4px",
                                    marginTop: "15px",
                                  }}
                                >
                                  Reel OD
                                </p>
                                <Col className="blockBreak">
                                  <div className="boxFormType">
                                    <PaperMachineQualitySelect>
                                      <MultiSelectCard>
                                        <Multiselect
                                          className="multiQuality"
                                          options={reelValues}
                                          style={multiselectStyle}
                                          showArrow={true}
                                          selectedValues={selectedReelOD}
                                          displayValue={"value"}
                                          showCheckbox={true}
                                          disable={
                                            // (props.isEditFromIncompleteOrder && props.type === "deckleRecord") ||
                                            // (props.isEditFromIncompleteOrder && !orderMangtSettings?.data?.edit_after_approval?.value)
                                            props?.actionType == "view"
                                          }
                                          onSelect={onChangeReelOdSelect}
                                          onRemove={onChangeReelOdSelect}
                                          hideSelectedList
                                          keepSearchTerm
                                        />
                                      </MultiSelectCard>
                                    </PaperMachineQualitySelect>
                                  </div>
                                  {/* )} */}
                                  <Col span={12}>
                                    <PaperMachineGradeSelect>
                                      {selectedReelOD &&
                                      selectedReelOD?.length ? (
                                        <>
                                          {selectedReelOD &&
                                          selectedReelOD?.length ? (
                                            <div className="mainMachineGrade">
                                              {selectedReelOD &&
                                                selectedReelOD?.length &&
                                                selectedReelOD?.map(
                                                  (item, index) => {
                                                    return (
                                                      index <= 10 && (
                                                        <span
                                                          className={
                                                            "MachineGradeSelect-active"
                                                          }
                                                        >
                                                          {item?.value}
                                                          <Button
                                                            className="textTypeBtn textBtnIcon paperButtonBg"
                                                            onClick={() => {
                                                              removeReelOD(
                                                                item
                                                              );
                                                            }}
                                                            disabled={
                                                              // (props?.actionType == "view") || (props.isEditFromIncompleteOrder && props.type === "deckleRecord") ||
                                                              // (props.isEditFromIncompleteOrder && props.type === "orderRecord" && !orderMangtSettings?.data?.edit_after_approval?.value)
                                                              props?.actionType ==
                                                              "view"
                                                            }
                                                          >
                                                            <Iconmoon
                                                              icon="wrong"
                                                              size={14}
                                                              color="#EA655B"
                                                            />
                                                          </Button>
                                                        </span>
                                                      )
                                                    );
                                                  }
                                                )}
                                            </div>
                                          ) : null}
                                          {selectedReelOD &&
                                            selectedReelOD?.length &&
                                            selectedReelOD?.length > 10 &&
                                            selectedReelOD?.map(
                                              (item, index) => {
                                                let tooltipData = "";
                                                for (
                                                  let index = 10;
                                                  index <
                                                  selectedReelOD?.length;
                                                  index++
                                                ) {
                                                  const data =
                                                    selectedReelOD[index];
                                                  tooltipData =
                                                    tooltipData +
                                                    data?.value +
                                                    ", ";
                                                }
                                                tooltipData =
                                                  tooltipData.substring(
                                                    0,
                                                    tooltipData.length - 1
                                                  );
                                                return (
                                                  index == 11 && (
                                                    <Tooltip
                                                      title={tooltipData}
                                                    >
                                                      {" "}
                                                      <span
                                                        style={{
                                                          display: "flex",
                                                          justifyContent:
                                                            "flex-end",
                                                        }}
                                                      >
                                                        &{" "}
                                                        {selectedReelOD.length -
                                                          10}{" "}
                                                        More
                                                      </span>
                                                    </Tooltip>
                                                  )
                                                );
                                              }
                                            )}
                                        </>
                                      ) : null}
                                    </PaperMachineGradeSelect>
                                  </Col>
                                </Col>
                              </div>
                            )
                          ) : (
                            <div style={{ marginTop: "20px" }}>
                              <Col span={24}>
                                <Row className="centerAlign justifyCSBetween">
                                  <Col span={8} className="blockBreak">
                                    <div
                                      className="boxFormType"
                                      style={{ marginBottom: "0" }}
                                    >
                                      <Form.Item
                                        label="Min Reel OD"
                                        name="min_reel_od"
                                        rules={[
                                          {
                                            pattern: new RegExp(
                                              /^\d+(\.\d{0,3})?$/
                                            ),
                                            message:
                                              "Only Numeric value is possible upto 3 decimal point",
                                          },
                                        ]}
                                        className="dBlock"
                                        initialValue={details?.minimum_reel_od}
                                      >
                                        <Input
                                          placeholder="Min Reel OD"
                                          className={
                                            reelODValidationError
                                              ? "showErrorBorder"
                                              : ""
                                          }
                                          onChange={(e) => {
                                            onMinReelODChange(e);
                                          }}
                                        />
                                      </Form.Item>
                                    </div>
                                  </Col>
                                  <Col span={8} className="blockBreak">
                                    <div
                                      className="boxFormType"
                                      style={{ marginBottom: "0" }}
                                    >
                                      <Form.Item
                                        label="Max Reel OD"
                                        name="max_reel_od"
                                        rules={[
                                          {
                                            pattern: new RegExp(
                                              /^\d+(\.\d{0,3})?$/
                                            ),
                                            message:
                                              "Only Numeric value is possible upto 3 decimal point",
                                          },
                                        ]}
                                        className="dBlock"
                                        initialValue={details?.maximum_reel_od}
                                      >
                                        <Input
                                          placeholder="Max Reel OD"
                                          className={
                                            reelODValidationError
                                              ? "showErrorBorder"
                                              : ""
                                          }
                                          onChange={(e) => {
                                            onMaxReelODChange(e);
                                          }}
                                        />
                                      </Form.Item>
                                    </div>
                                  </Col>
                                  <Col span={7} className="blockBreak">
                                    <div className="boxFormType unitSelect">
                                      <Form.Item
                                        label="Unit"
                                        name="reelOD_unit"
                                        rules={[]}
                                        className="dBlock"
                                        style={{ width: "100px" }}
                                        initialValue={
                                          details?.units?.minimum_reel_od
                                        }
                                      >
                                        <Select
                                          placeholder="Unit"
                                          suffixIcon={<DownArrowDraw />}
                                          className="dBlock"
                                          onChange={(e) => {
                                            onRangeUnitChange(e);
                                          }}
                                        >
                                          {measurementData?.data.units_management.length.data?.map(
                                            (reelUnit) => (
                                              <Option
                                                key={reelUnit}
                                                value={reelUnit}
                                              >
                                                {
                                                  lengthUnit[reelUnit]
                                                    ?.displayName
                                                }
                                              </Option>
                                            )
                                          )}
                                        </Select>
                                      </Form.Item>
                                    </div>
                                  </Col>
                                  {reelODValidationError ? (
                                    <span
                                      className="errorText"
                                      style={{
                                        color: "#ea4e2c",
                                        marginTop: "-2px",
                                      }}
                                    >
                                      Max dia cannot be less than Min dia
                                    </span>
                                  ) : null}
                                  {rangeValidationError ? (
                                    <span
                                      className="errorText"
                                      style={{
                                        color: "#ea4e2c",
                                        marginTop: "-2px",
                                      }}
                                    >
                                      Min Reel dia cannot be less than Core OD
                                    </span>
                                  ) : null}
                                </Row>
                              </Col>
                            </div>
                          )}

                          {((selectedReelOD && selectedReelOD?.length == 1) ||
                            (reelOD &&
                              orderQuantity == "reel" &&
                              selectedType == "reel")) &&
                          outerDiameter !== "range" ? (
                            <div>
                              {orderQuantity?.toLowerCase() != "reel" && (
                                <div className="titleWithText">
                                  <h5
                                    style={{
                                      color: "#ea655b",
                                      marginTop: "10px",
                                    }}
                                  >
                                    Calculated number of reels on specified Core{" "}
                                  </h5>
                                  <h5
                                    style={{
                                      color: "#ea655b",
                                      marginTop: "5px",
                                    }}
                                  >
                                    OD & Reel OD: {plannedReels}
                                  </h5>
                                </div>
                              )}
                              <Row className="centerAlign justifyCSBetween">
                                <Col span={10}>
                                  <div className="boxFormType">
                                    <p
                                      style={{
                                        marginBottom: "3px",
                                        marginTop: "12px",
                                      }}
                                    >
                                      Rewinder Reels
                                    </p>
                                    <Form.Item
                                      name="no_of_reel_sheet"
                                      rules={[
                                        {
                                          pattern: new RegExp(
                                            /^\d+(\.\d{0,3})?$/
                                          ),
                                          message:
                                            "Only numeric characters upto 3 decimal points are allowed",
                                        },
                                      ]}
                                      className="dBlock"
                                    >
                                      <Input
                                        placeholder="Enter the number of reels"
                                        onChange={(e) => {
                                          onPlannedReelsChange(e);
                                        }}
                                        disabled={
                                          // (props.isEditFromIncompleteOrder && props.type === "deckleRecord") ||
                                          (props.isEditFromIncompleteOrder &&
                                            !orderMangtSettings?.data
                                              ?.edit_after_approval?.value) ||
                                          props?.actionType == "view" ||
                                          (orderQuantity == "reel" &&
                                            selectedType == "reel")
                                        }
                                      />
                                    </Form.Item>
                                  </div>
                                </Col>
                                <Col span={13}>
                                  <div className="boxFormType">
                                    <p
                                      style={{
                                        marginBottom: "3px",
                                        marginTop: "12px",
                                      }}
                                    >
                                      Planned Weight
                                    </p>
                                    <Form.Item
                                      name="planned_weight"
                                      rules={[]}
                                      className=""
                                    >
                                      <Input
                                        style={{ width: "185px" }}
                                        disabled
                                      />
                                    </Form.Item>
                                    <div
                                      style={{
                                        marginTop: "-57px",
                                        marginLeft:
                                          weightUnit[unitPlaceholder]
                                            ?.displayName == "US - Ton"
                                            ? "116px"
                                            : weightUnit[unitPlaceholder]
                                                ?.displayName == "ton" ||
                                              weightUnit[unitPlaceholder]
                                                ?.displayName == "kg"
                                            ? "152px"
                                            : "168px",
                                        position: "relative",
                                        fontFamily: "var(--sf-pro-text)",
                                        color: "#a19f9d",
                                        width: "max-content"
                                      }}
                                    >
                                      {weightUnit[unitPlaceholder]?.displayName}
                                    </div>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          ) : null}
                        </div>
                      </Panel>
                    </Collapse>
                  </div>
                )}

                {props?.type == "deckleRecord" &&
                  props?.actionType == "edit" && (
                    <div className="drawerField">
                      <div>
                        <div className="titleWithText">
                          <h5 style={{ marginTop: "-15px" }}>
                            Planning Details
                          </h5>
                          <p>
                            Quantity pending to be processed and associated
                            rewinder details for the quantity
                          </p>
                        </div>
                      </div>
                      <div className="titleWithText">
                        <p
                          style={{
                            borderBottom: "1px solid #edebe9",
                            paddingBottom: "16px",
                          }}
                        >
                          Pending Quantity:{" "}
                          {/* {orderQuantity === "weight" ? ((pendingQuantity ? (pendingQuantity + " " + (unitPlaceholder ? capitalize(weightUnit[unitPlaceholder]?.displayName) : "")) : "")) : 
                          ((details?.total_pending_quantity?.weight == pendingQuantity && orderQuantity == "sheet") ? 
                          (pendingQuantity + " " + (unitPlaceholder ? capitalize(weightUnit[unitPlaceholder]?.displayName) : "")) :
                          (pendingQuantity ? (pendingQuantity + " " + capitalize(orderQuantity) + "s") : ""))} */}
                          {orderQuantity === "weight"
                            ? pendingQuantity || pendingQuantity == 0
                              ? pendingQuantity +
                                " " +
                                (unitPlaceholder
                                  ? capitalize(
                                      weightUnit[unitPlaceholder]?.displayName
                                    )
                                  : "")
                              : ""
                            : orderQuantity == "sheet"
                            ? pendingQuantity +
                              " (" +
                              pendingQntWeight +
                              (unitPlaceholder
                                ? capitalize(
                                    weightUnit[unitPlaceholder]?.displayName
                                  )
                                : "") +
                              ")"
                            : pendingQuantity || pendingQuantity == 0
                            ? pendingQuantity +
                              " " +
                              capitalize(orderQuantity) +
                              "s"
                            : ""}
                        </p>
                      </div>
                      <div
                        className="drawerField"
                        style={{ marginRight: "15px", marginTop: "-10px" }}
                      >
                        <div className="titleWithText">
                          <h5>Quantity to be planned</h5>
                          <p>Quantity of the order to be planned</p>
                        </div>
                        <div
                          className=" switchRadio twoSwitch"
                          style={{
                            justifyContent: "center",
                            display: "flex",
                            marginRight: "-8px",
                          }}
                        >
                          <Radio.Group
                            options={orderQuantityTab}
                            optionType="button"
                            buttonStyle="solid"
                            value={orderQuantity}
                            disabled={true}
                          />
                        </div>
                        {orderQuantity === "weight" ? (
                          <>
                            <div className="subTitleWithText">
                              <p></p>
                            </div>
                            <div style={{ position: "relative" }}>
                              <Row className="centerAlign justifyCSBetween">
                                <Col span={13}>
                                  <div className="boxFormType">
                                    <Form.Item
                                      name="planning_weight"
                                      rules={[
                                        {
                                          required: true,
                                          message: "This field is required",
                                        },
                                        {
                                          pattern: new RegExp(
                                            /^\d+(\.\d{0,3})?$/
                                          ),
                                          message:
                                            "This value should be a non-zero positive value",
                                        },
                                        {
                                          pattern: new RegExp(
                                            /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                                          ),
                                          message:
                                            "Weight should be a number greater than zero",
                                        },
                                      ]}
                                      className="dBlock"
                                      initialValue={details?.planning_weight}
                                    >
                                      <Input
                                        style={{ width: "185px" }}
                                        placeholder="Enter weight"
                                        onChange={(e) => {
                                          handlePlanningWeight(e);
                                        }}
                                        disabled={
                                          // (props.isEditFromIncompleteOrder && props.type === "deckleRecord") ||
                                          (props.isEditFromIncompleteOrder &&
                                            !orderMangtSettings?.data
                                              ?.edit_after_approval?.value) ||
                                          props?.actionType == "view"
                                        }
                                      />
                                    </Form.Item>
                                  </div>
                                </Col>
                                <Col span={10}>
                                  <div
                                    className="boxFormType"
                                    style={{ marginLeft: "10px" }}
                                  >
                                    <Form.Item
                                      name="planning_weightUnit"
                                      rules={[
                                        {
                                          required: true,
                                          message: "This field is required",
                                        },
                                      ]}
                                      className="dBlock"
                                      initialValue={unitPlaceholder}
                                    >
                                      <Select
                                        placeholder="Unit"
                                        suffixIcon={<DownArrowDraw />}
                                        disabled={true}
                                      >
                                        {weightUnitList?.map((unitItem) => (
                                          <Option
                                            key={unitItem}
                                            value={unitItem}
                                          >
                                            {weightUnit[unitItem]?.displayName}
                                          </Option>
                                        ))}
                                      </Select>
                                    </Form.Item>
                                  </div>
                                </Col>
                                {planningWtErr ? (
                                  <span
                                    className="errorText"
                                    style={{
                                      color: "#ea4e2c",
                                      marginTop: "-17px",
                                      marginBottom: "5px",
                                    }}
                                  >
                                    Quantity to be planned cannot be more than
                                    the pending quantity
                                  </span>
                                ) : null}
                              </Row>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="subTitleWithText">
                              <p></p>
                            </div>
                            <div style={{ position: "relative" }}>
                              <Form.Item
                                name="planning_quantity"
                                rules={[
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                  {
                                    pattern: new RegExp(/^\d+(\.\d+)?$/),
                                    message:
                                      "This value should be a non-zero positive value",
                                  },
                                  {
                                    pattern: new RegExp(
                                      /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                                    ),
                                    message:
                                      "Quantity should be a number greater than zero",
                                  },
                                ]}
                                className=""
                                initialValue={details?.planning_quantity}
                              >
                                <Input
                                  style={{ width: "332px" }}
                                  placeholder="Enter quantity"
                                  onChange={(e) => {
                                    onPlanningQuantityValueChange(e);
                                  }}
                                  disabled={
                                    // (props.isEditFromIncompleteOrder && props.type === "deckleRecord") ||
                                    (props.isEditFromIncompleteOrder &&
                                      !orderMangtSettings?.data
                                        ?.edit_after_approval?.value) ||
                                    props?.actionType == "view"
                                  }
                                />
                              </Form.Item>
                              {planningWtErr ? (
                                <div
                                  className="errorText"
                                  style={{
                                    color: "#ea4e2c",
                                    marginTop: "-17px",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Quantity to be planned cannot be more than the
                                  pending quantity
                                </div>
                              ) : null}
                            </div>
                          </>
                        )}
                      </div>
                      <div
                        className="drawerField"
                        style={{
                          borderBottom: "0px solid #edebe9",
                          // marginLeft: "-12px",
                        }}
                      >
                        <div className="titleWithText">
                          <h5>Rewinder Details</h5>
                          <p>
                            The outer diameter of the reel and rewinder core
                          </p>
                        </div>

                        <div className="titleWithText">
                          <p style={{ marginLeft: "3px", marginBottom: "4px" }}>
                            Core OD
                          </p>
                        </div>
                        <Form.Item
                          name="core_OD"
                          rules={[]}
                          className="selectForm"
                        >
                          <Select
                            placeholder="Select Core OD"
                            suffixIcon={<DownArrowDraw />}
                            showSearch
                            optionFilterProp="children"
                            onChange={handleCoreOD}
                            // style={{ width: "331px" }}
                            disabled={
                              // (props.isEditFromIncompleteOrder && props.type === "deckleRecord") ||
                              //           (props.isEditFromIncompleteOrder && props.type === "orderRecord" && !orderMangtSettings?.data?.edit_after_approval?.value)
                              props?.actionType == "view"
                            }
                          >
                            {coreValues?.map((data) => (
                              <Option key={data?.value}>{data?.value}</Option>
                            ))}
                          </Select>
                        </Form.Item>
                        {coreOdValidationError ? (
                          <div
                            className="errorText"
                            style={{
                              color: "#ea4e2c",
                              marginLeft: "2px",
                              marginTop: "-22px",
                              marginBottom: "20px",
                            }}
                          >
                            Reel OD cannot be less than Core OD
                          </div>
                        ) : null}
                        <div
                          className=" switchRadio twoSwitch"
                          style={{
                            justifyContent: "center",
                            display: "flex",
                            // marginRight: "-8px",
                          }}
                        >
                          <Radio.Group
                            options={rewinderType}
                            optionType="button"
                            buttonStyle="solid"
                            value={outerDiameter}
                            disabled={
                              (selectedType == "reel" &&
                                orderQuantity == "reel") ||
                              // (props.isEditFromIncompleteOrder && props.type === "deckleRecord") ||
                              (props.isEditFromIncompleteOrder &&
                                !orderMangtSettings?.data?.edit_after_approval
                                  ?.value) ||
                              props?.actionType == "view"
                            }
                            onChange={handleRewinderType}
                          />
                        </div>
                        {outerDiameter === "constant" ? (
                          selectedType == "reel" && orderQuantity == "reel" ? (
                            <div className="titleWithText">
                              <p
                                style={{
                                  marginLeft: "3px",
                                  marginBottom: "4px",
                                  marginTop: "22px",
                                }}
                              >
                                Reel OD
                              </p>
                              <Form.Item
                                name="reel_OD"
                                rules={[]}
                                className="selectForm"
                              >
                                <Select
                                  placeholder="Select Reel OD"
                                  suffixIcon={<DownArrowDraw />}
                                  showSearch
                                  optionFilterProp="children"
                                  onChange={handleReelOD}
                                  // style={{ width: "331px" }}
                                  disabled={
                                    // (props.isEditFromIncompleteOrder && props.type === "deckleRecord") ||
                                    //       (props.isEditFromIncompleteOrder && props.type === "orderRecord" && !orderMangtSettings?.data?.edit_after_approval?.value)
                                    props?.actionType == "view"
                                  }
                                >
                                  {reelValues?.map((data) => (
                                    <Option key={data?.value}>
                                      {data?.value}
                                    </Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </div>
                          ) : (
                            <div>
                              <p
                                style={{
                                  marginLeft: "3px",
                                  marginBottom: "4px",
                                  marginTop: "15px",
                                }}
                              >
                                Reel OD
                              </p>
                              <Col className="blockBreak">
                                <div className="boxFormType">
                                  <PaperMachineQualitySelect>
                                    <MultiSelectCard>
                                      <Multiselect
                                        className="multiQuality"
                                        options={reelValues}
                                        style={multiselectStyle}
                                        showArrow={true}
                                        selectedValues={selectedReelOD}
                                        displayValue={"value"}
                                        showCheckbox={true}
                                        disable={
                                          // (props.isEditFromIncompleteOrder && props.type === "deckleRecord") ||
                                          // (props.isEditFromIncompleteOrder && !orderMangtSettings?.data?.edit_after_approval?.value)
                                          props?.actionType == "view"
                                        }
                                        onSelect={onChangeReelOdSelect}
                                        onRemove={onChangeReelOdSelect}
                                        hideSelectedList
                                        keepSearchTerm
                                      />
                                    </MultiSelectCard>
                                  </PaperMachineQualitySelect>
                                </div>
                                {/* )} */}
                                <Col span={12}>
                                  <PaperMachineGradeSelect>
                                    <div className="mainMachineGrade">
                                      {selectedReelOD &&
                                        selectedReelOD?.map((item, index) => {
                                          return (
                                            index <= 10 && (
                                              <span
                                                className={
                                                  "MachineGradeSelect-active"
                                                }
                                              >
                                                {item.value}
                                                <Button
                                                  className="textTypeBtn textBtnIcon paperButtonBg"
                                                  onClick={() => {
                                                    removeReelOD(item);
                                                  }}
                                                  disabled={
                                                    // (props?.actionType == "view") || (props.isEditFromIncompleteOrder && props.type === "deckleRecord") ||
                                                    (props.isEditFromIncompleteOrder &&
                                                      !orderMangtSettings?.data
                                                        ?.edit_after_approval
                                                        ?.value) ||
                                                    props?.actionType == "view"
                                                  }
                                                >
                                                  <Iconmoon
                                                    icon="wrong"
                                                    size={14}
                                                    color="#EA655B"
                                                  />
                                                </Button>
                                              </span>
                                            )
                                          );
                                        })}
                                    </div>
                                    {selectedReelOD &&
                                      selectedReelOD?.length > 10 &&
                                      selectedReelOD?.map((item, index) => {
                                        let tooltipData = "";
                                        for (
                                          let index = 10;
                                          index < selectedReelOD?.length;
                                          index++
                                        ) {
                                          const data = selectedReelOD[index];
                                          tooltipData =
                                            tooltipData + data.value + ", ";
                                        }
                                        tooltipData = tooltipData.substring(
                                          0,
                                          tooltipData.length - 1
                                        );
                                        return (
                                          index == 11 && (
                                            <Tooltip title={tooltipData}>
                                              {" "}
                                              <span
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "flex-end",
                                                }}
                                              >
                                                & {selectedReelOD.length - 10}{" "}
                                                More
                                              </span>
                                            </Tooltip>
                                          )
                                        );
                                      })}
                                  </PaperMachineGradeSelect>
                                </Col>
                              </Col>
                            </div>
                          )
                        ) : (
                          <div style={{ marginTop: "20px" }}>
                            <Col span={24}>
                              <Row className="centerAlign justifyCSBetween">
                                <Col span={8} className="blockBreak">
                                  <div
                                    className="boxFormType"
                                    style={{ marginBottom: "0" }}
                                  >
                                    <Form.Item
                                      label="Min Reel OD"
                                      name="min_reel_od"
                                      rules={[
                                        {
                                          pattern: new RegExp(
                                            /^\d+(\.\d{0,3})?$/
                                          ),
                                          message:
                                            "Only Numeric value is possible upto 3 decimal point",
                                        },
                                      ]}
                                      className="dBlock"
                                      initialValue={details?.minimum_reel_od}
                                    >
                                      <Input
                                        placeholder="Min Reel OD"
                                        className={
                                          reelODValidationError
                                            ? "showErrorBorder"
                                            : ""
                                        }
                                        onChange={(e) => {
                                          onMinReelODChange(e);
                                        }}
                                      />
                                    </Form.Item>
                                  </div>
                                </Col>
                                <Col span={8} className="blockBreak">
                                  <div
                                    className="boxFormType"
                                    style={{ marginBottom: "0" }}
                                  >
                                    <Form.Item
                                      label="Max Reel OD"
                                      name="max_reel_od"
                                      rules={[
                                        {
                                          pattern: new RegExp(
                                            /^\d+(\.\d{0,3})?$/
                                          ),
                                          message:
                                            "Only Numeric value is possible upto 3 decimal point",
                                        },
                                      ]}
                                      className="dBlock"
                                      initialValue={details?.maximum_reel_od}
                                    >
                                      <Input
                                        placeholder="Max Reel OD"
                                        className={
                                          reelODValidationError
                                            ? "showErrorBorder"
                                            : ""
                                        }
                                        onChange={(e) => {
                                          onMaxReelODChange(e);
                                        }}
                                      />
                                    </Form.Item>
                                  </div>
                                </Col>
                                <Col span={7} className="blockBreak">
                                  <div className="boxFormType unitSelect">
                                    <Form.Item
                                      label="Unit"
                                      name="reelOD_unit"
                                      rules={[]}
                                      className="dBlock"
                                      style={{ width: "100px" }}
                                      initialValue={
                                        details?.units?.minimum_reel_od
                                      }
                                    >
                                      <Select
                                        placeholder="Unit"
                                        suffixIcon={<DownArrowDraw />}
                                        className="dBlock"
                                        onChange={(e) => {
                                          onRangeUnitChange(e);
                                        }}
                                      >
                                        {measurementData?.data.units_management.length.data?.map(
                                          (reelUnit) => (
                                            <Option
                                              key={reelUnit}
                                              value={reelUnit}
                                            >
                                              {
                                                lengthUnit[reelUnit]
                                                  ?.displayName
                                              }
                                            </Option>
                                          )
                                        )}
                                      </Select>
                                    </Form.Item>
                                  </div>
                                </Col>
                                {reelODValidationError ? (
                                  <span
                                    className="errorText"
                                    style={{
                                      color: "#ea4e2c",
                                      marginTop: "-2px",
                                    }}
                                  >
                                    Max dia cannot be less than Min dia
                                  </span>
                                ) : null}
                                {rangeValidationError ? (
                                  <span
                                    className="errorText"
                                    style={{
                                      color: "#ea4e2c",
                                      marginTop: "-2px",
                                    }}
                                  >
                                    Min Reel dia cannot be less than Core OD
                                  </span>
                                ) : null}
                              </Row>
                            </Col>
                          </div>
                        )}

                        {((selectedReelOD && selectedReelOD?.length == 1) ||
                          (reelOD &&
                            orderQuantity == "reel" &&
                            selectedType == "reel")) &&
                        outerDiameter !== "range" ? (
                          <div>
                            {orderQuantity?.toLowerCase() != "reel" && (
                              <div className="titleWithText">
                                <h5
                                  style={{
                                    color: "#ea655b",
                                    marginTop: "10px",
                                  }}
                                >
                                  Calculated number of reels on specified Core{" "}
                                </h5>
                                <h5
                                  style={{
                                    color: "#ea655b",
                                    marginTop: "5px",
                                  }}
                                >
                                  OD & Reel OD: {plannedReels}
                                </h5>
                              </div>
                            )}
                            <Row className="centerAlign justifyCSBetween">
                              <Col span={10}>
                                <div className="boxFormType">
                                  <p
                                    style={{
                                      marginBottom: "3px",
                                      marginTop: "12px",
                                    }}
                                  >
                                    Rewinder Reels
                                  </p>
                                  <Form.Item
                                    name="no_of_reel_sheet"
                                    rules={[
                                      {
                                        pattern: new RegExp(
                                          /^\d+(\.\d{0,3})?$/
                                        ),
                                        message:
                                          "Only numeric characters upto 3 decimal points are allowed",
                                      },
                                    ]}
                                    className="dBlock"
                                  >
                                    <Input
                                      placeholder="Enter the number of reels"
                                      onChange={(e) => {
                                        onPlannedReelsChange(e);
                                      }}
                                      disabled={
                                        // (props.isEditFromIncompleteOrder && props.type === "deckleRecord") ||
                                        (props.isEditFromIncompleteOrder &&
                                          !orderMangtSettings?.data
                                            ?.edit_after_approval?.value) ||
                                        props?.actionType == "view" ||
                                        (orderQuantity == "reel" &&
                                          selectedType == "reel")
                                      }
                                    />
                                  </Form.Item>
                                </div>
                              </Col>
                              <Col span={13}>
                                <div className="boxFormType">
                                  <p
                                    style={{
                                      marginBottom: "3px",
                                      marginTop: "12px",
                                    }}
                                  >
                                    Planned Weight
                                  </p>
                                  <Form.Item
                                    name="planned_weight"
                                    rules={[]}
                                    className=""
                                  >
                                    <Input
                                      style={{ width: "185px" }}
                                      disabled
                                    />
                                  </Form.Item>
                                  <div
                                    style={{
                                      marginTop: "-57px",
                                      marginLeft:
                                        weightUnit[unitPlaceholder]
                                          ?.displayName == "US - Ton"
                                          ? "116px"
                                          : weightUnit[unitPlaceholder]
                                              ?.displayName == "ton" ||
                                            weightUnit[unitPlaceholder]
                                              ?.displayName == "kg"
                                          ? "152px"
                                          : "168px",
                                      position: "relative",
                                      fontFamily: "var(--sf-pro-text)",
                                      color: "#a19f9d",
                                      width: "max-content"
                                    }}
                                  >
                                    {weightUnit[unitPlaceholder]?.displayName}
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  )}

                {props?.actionType !== "view" && (
                  <div className="buttonFlex fixedBtm">
                    <Form.Item>
                      {(props?.selectedState === "Changes Req" ||
                        props?.selectedState === "Cancelled" ||
                        props?.selectedState === "cancel" ||
                        (props?.selectedState === "Approved" &&
                          orderMangtSettings?.data?.edit_after_approval
                            ?.value &&
                          props.type === "orderRecord")) &&
                      props?.actionType != "view" ? (
                        <Button htmlType="submit" className="themeBtn">
                          <Iconmoon
                            icon="addcircle"
                            size={16}
                            color="#ffffff"
                          />{" "}
                          Resend for approval{" "}
                        </Button>
                      ) : (
                        <Button htmlType="submit" className="themeBtn">
                          <Iconmoon
                            icon="addcircle"
                            size={16}
                            color="#ffffff"
                          />{" "}
                          Save{" "}
                        </Button>
                      )}
                    </Form.Item>
                    <Form.Item>
                      <Button
                        key="3"
                        className="textTypeBtn"
                        onClick={() => {
                          cancelChanges();
                        }}
                      >
                        Cancel changes
                      </Button>
                    </Form.Item>
                  </div>
                )}

                {props?.actionType == "view" &&
                  props?.type !== "deckleRecord" && (
                    <div
                      className="buttonFlex fixedBtm"
                      style={{ flexDirection: "row", left: "-14px" }}
                    >
                      {props.roles && props?.actionType == "view" && (
                        <div style={{ display: "flex", flexDirection: "row" }}>
                          {(props.roles.edit_own ||
                            props.roles.edit_all ||
                            props.roles.edit) &&
                          props?.type !== "approveOrder" ? (
                            <Form.Item>
                              <Dropdown
                                className="viewDropdownStyle"
                                overlay={
                                  <Menu>
                                    {details.state === "approved" && props.selectedOrder.isEditAllowed&& (
                                      <Menu.Item
                                        key="1"
                                        style={{
                                          marginTop: "-5px",
                                          marginBottom: "-10px",
                                        }}
                                      >
                                        <DisabledButtonStyle>
                                          <Button
                                            style={{
                                              border: "none",
                                              background: "none",
                                              padding: "0",
                                              font: "inherit",
                                              textAlign: "left",
                                              width: "100%",
                                            }}
                                            // disabled={details.state !== "approved"}
                                            onClick={() =>
                                              handlePriorityAction()
                                            }
                                          >
                                            <span
                                              style={{
                                                color:
                                                  details.state !== "approved"
                                                    ? "#A19F9D"
                                                    : "rgba(0, 0, 0, 0.85)",
                                              }}
                                            >
                                              {details?.priority
                                                ? "Remove Priority"
                                                : "Prioritize this order"}
                                            </span>
                                          </Button>
                                        </DisabledButtonStyle>
                                      </Menu.Item>
                                    )}
                                    {/* {
                                    <Tooltip
                                    title={
                                      props?.selectedOrder?.priority &&
                                      "Priority orders cannot be merged"
                                    }
                                    >
                                      <Menu.Item key="2">
                                          <DisabledButtonStyle>
                                              {details.state !== "cancel" ? (
                                              (details.split_type != "auto") && (<Button
                                                style={{
                                                  border: "none",
                                                  background: "none",
                                                  padding: "0",
                                                  font: "inherit",
                                                  textAlign: "left",
                                                  width: "100%",
                                                }}
                                                disabled={
                                                  props?.selectedOrder?.status !== "Approved" ||
                                                  props?.selectedOrder?.priority ||
                                                  props?.selectedOrder?.completed != 0 ||
                                                  props?.selectedOrder?.in_production != 0 ||
                                                  props?.selectedOrder?.in_process != 0 ||
                                                  !props?.selectedOrder?.parent
                                                }
                                                onClick={() => onMergeOrderHandler()}
                                              >
                                                <span
                                                  style={{
                                                    color:
                                                      props?.selectedOrder?.status !== "Approved" ||
                                                      props?.selectedOrder?.priority ||
                                                      props?.selectedOrder?.completed != 0 ||
                                                      props?.selectedOrder?.in_production != 0 ||
                                                      props?.selectedOrder?.in_process != 0 ||
                                                      !props?.selectedOrder?.parent
                                                        ? "#A19F9D"
                                                        : "rgba(0, 0, 0, 0.85)",
                                                  }}
                                                >
                                                  Merge Order
                                                </span>
                                              </Button>)) : (
                                                <Button
                                                style={{
                                                  border: "none",
                                                  background: "none",
                                                  padding: "0",
                                                  font: "inherit",
                                                  textAlign: "left",
                                                  width: "100%",
                                                }}
                                                onClick={() => handleRestore()}
                                              >
                                                <span
                                                  style={{
                                                    color: "rgba(0, 0, 0, 0.85)",
                                                  }}
                                                >
                                                  Restore Order
                                                </span>
                                              </Button>
                                              )}
                                            </DisabledButtonStyle>
                                      </Menu.Item>
                                    </Tooltip>
                                  } */}
                                    {details.state !== "cancel" &&
                                      details?.split_type != "auto" &&
                                      props?.selectedOrder?.status ==
                                        "Approved" &&
                                      !props?.selectedOrder?.priority &&
                                      props?.selectedOrder?.completed == 0 &&
                                      props?.selectedOrder?.in_production ==
                                        0 &&
                                      props?.selectedOrder?.in_process == 0 &&
                                      props?.selectedOrder?.parent &&  props.selectedOrder.isEditAllowed&& (
                                        <Menu.Item
                                          key="2"
                                          style={{ marginBottom: "-10px" }}
                                        >
                                          <DisabledButtonStyle>
                                            <Button
                                              style={{
                                                border: "none",
                                                background: "none",
                                                padding: "0",
                                                font: "inherit",
                                                textAlign: "left",
                                                width: "100%",
                                              }}
                                              disabled={
                                                props?.selectedOrder?.status !==
                                                  "Approved" ||
                                                props?.selectedOrder
                                                  ?.priority ||
                                                props?.selectedOrder
                                                  ?.completed != 0 ||
                                                props?.selectedOrder
                                                  ?.in_production != 0 ||
                                                props?.selectedOrder
                                                  ?.in_process != 0 ||
                                                !props?.selectedOrder?.parent
                                              }
                                              onClick={() =>
                                                onMergeOrderHandler()
                                              }
                                            >
                                              <span
                                                style={{
                                                  color:
                                                    props?.selectedOrder
                                                      ?.status !== "Approved" ||
                                                    props?.selectedOrder
                                                      ?.priority ||
                                                    props?.selectedOrder
                                                      ?.completed != 0 ||
                                                    props?.selectedOrder
                                                      ?.in_production != 0 ||
                                                    props?.selectedOrder
                                                      ?.in_process != 0 ||
                                                    !props?.selectedOrder
                                                      ?.parent
                                                      ? "#A19F9D"
                                                      : "rgba(0, 0, 0, 0.85)",
                                                }}
                                              >
                                                Merge Order
                                              </span>
                                            </Button>
                                          </DisabledButtonStyle>
                                        </Menu.Item>
                                      )}

                                    {details.state == "cancel" &&  props.selectedOrder.isEditAllowed&& (
                                      <Menu.Item
                                        key="3"
                                        style={{ marginBottom: "-10px" }}
                                      >
                                        <DisabledButtonStyle>
                                          <Button
                                            style={{
                                              border: "none",
                                              background: "none",
                                              padding: "0",
                                              font: "inherit",
                                              textAlign: "left",
                                              width: "100%",
                                            }}
                                            onClick={() => handleRestore()}
                                          >
                                            <span
                                              style={{
                                                color: "rgba(0, 0, 0, 0.85)",
                                              }}
                                            >
                                              Restore Order
                                            </span>
                                          </Button>
                                        </DisabledButtonStyle>
                                      </Menu.Item>
                                    )}
                                    {details.state == "approved" &&
                                      !details?.priority &&
                                      details?.pending_quantity != 0 &&
                                      props.id == details.user && props.selectedOrder.isEditAllowed&&  (
                                        <Menu.Item
                                          key="4"
                                          style={{ marginBottom: "-10px" }}
                                        >
                                          <DisabledButtonStyle>
                                            <Button
                                              style={{
                                                border: "none",
                                                background: "none",
                                                padding: "0",
                                                font: "inherit",
                                                textAlign: "left",
                                                width: "100%",
                                              }}
                                              disabled={
                                                details.state !== "approved"
                                              }
                                              onClick={() =>
                                                splitOrderHandler()
                                              }
                                            >
                                              <span
                                                style={{
                                                  color:
                                                    details.state !== "approved"
                                                      ? "#A19F9D"
                                                      : "rgba(0, 0, 0, 0.85)",
                                                }}
                                              >
                                                Split Order
                                              </span>
                                            </Button>
                                          </DisabledButtonStyle>
                                        </Menu.Item>
                                      )}
                                    {details.state == "approved" && props.selectedOrder.isEditAllowed&& (
                                      <Menu.Item
                                        key="5"
                                        style={{ marginBottom: "-10px" }}
                                      >
                                        <DisabledButtonStyle>
                                          <Button
                                            onClick={onCancelQuantityHandler}
                                            style={{
                                              border: "none",
                                              background: "none",
                                              color: "inherit",
                                              padding: "0",
                                              font: "inherit",
                                              cursor: "pointer",
                                              outline: "inherit",
                                              textAlign: "left",
                                            }}
                                          >
                                            Cancel Quantity
                                          </Button>{" "}
                                        </DisabledButtonStyle>
                                      </Menu.Item>
                                    )}
                                    {(details.state == "approved" ||
                                      details.state == "hold") && (
                                      <Menu.Item
                                        key="6"
                                        style={{ marginBottom: "-10px" }}
                                      >
                                        <DisabledButtonStyle>
                                          <Button
                                            style={{
                                              border: "none",
                                              background: "none",
                                              padding: "0",
                                              font: "inherit",
                                              textAlign: "left",
                                              width: "100%",
                                            }}
                                            disabled={
                                              details.state !== "approved" &&
                                              details.state != "hold"
                                            }
                                            onClick={() =>
                                              handleViewProdDetails()
                                            }
                                          >
                                            <span
                                              style={{
                                                color:
                                                  details.state !==
                                                    "approved" &&
                                                  details.state != "hold"
                                                    ? "#A19F9D"
                                                    : "rgba(0, 0, 0, 0.85)",
                                              }}
                                            >
                                              View Production Details
                                            </span>
                                          </Button>
                                        </DisabledButtonStyle>
                                      </Menu.Item>
                                    )}
                                    {["hold", "approved"].includes(
                                      details?.state
                                    ) ? (
                                      <Menu.Item
                                        key="7"
                                        style={{ marginBottom: "-10px" }}
                                      >
                                        <Button
                                          style={{
                                            border: "none",
                                            background: "none",
                                            padding: "0",
                                            font: "inherit",
                                            textAlign: "left",
                                            width: "100%",
                                          }}
                                          onClick={() => {
                                            handleViewProcessedQtyDetails();
                                          }}
                                        >
                                          <span
                                            style={{
                                              color:
                                                details.state !== "approved" &&
                                                details.state != "hold"
                                                  ? "#A19F9D"
                                                  : "rgba(0, 0, 0, 0.85)",
                                            }}
                                          >
                                            View Processed Quantity Details
                                          </span>
                                        </Button>
                                      </Menu.Item>
                                    ) : (
                                      ""
                                    )}
                                    {[
                                      "hold",
                                      "approved",
                                      "open",
                                      "review",
                                      "pending",
                                    ].includes(details?.state) && (
                                      <Menu.Item
                                        key="8"
                                        style={{ marginBottom: "-10px" }}
                                      >
                                        <Button
                                          style={{
                                            border: "none",
                                            background: "none",
                                            padding: "0",
                                            font: "inherit",
                                            textAlign: "left",
                                            width: "100%",
                                          }}
                                          onClick={() => {
                                            handleViewPendingQtyDetails();
                                          }}
                                        >
                                          <span
                                            style={{
                                              color: "rgba(0, 0, 0, 0.85)",
                                            }}
                                          >
                                            View Pending Quantity Details
                                          </span>
                                        </Button>
                                      </Menu.Item>
                                    )}
                                    <Menu.Item
                                      key="9"
                                      style={{ marginBottom: "-10px" }}
                                    >
                                      <DisabledButtonStyle>
                                        <Button
                                          onClick={onViewPODetailsHandler}
                                          style={{
                                            border: "none",
                                            background: "none",
                                            color: "inherit",
                                            padding: "0",
                                            font: "inherit",
                                            cursor: "pointer",
                                            outline: "inherit",
                                            textAlign: "left",
                                          }}
                                        >
                                           {props.category==='po'?"View PO Details":"View SO Details"}
                                        </Button>{" "}
                                      </DisabledButtonStyle>
                                    </Menu.Item>
                                    <Menu.Item
                                      key="10"
                                      style={{ marginBottom: "-10px" }}
                                    >
                                      <DisabledButtonStyle>
                                        <Button
                                          onClick={onViewChangeHandler}
                                          style={{
                                            border: "none",
                                            background: "none",
                                            color: "inherit",
                                            padding: "0",
                                            font: "inherit",
                                            cursor: "pointer",
                                            outline: "inherit",
                                            textAlign: "left",
                                          }}
                                        >
                                          View Change History
                                        </Button>{" "}
                                      </DisabledButtonStyle>
                                    </Menu.Item>
                                    {details.state == "open" && (
                                      <Menu.Item
                                        key="11"
                                        style={{ marginBottom: "-10px" }}
                                      >
                                        <DisabledButtonStyle>
                                          <Button
                                            style={{
                                              border: "none",
                                              background: "none",
                                              padding: "0",
                                              font: "inherit",
                                              textAlign: "left",
                                              width: "100%",
                                            }}
                                            disabled={details.state !== "open"}
                                            onClick={() => handleDelete()}
                                          >
                                            <span
                                              style={{
                                                color:
                                                  details.state !== "open"
                                                    ? "#A19F9D"
                                                    : "rgba(0, 0, 0, 0.85)",
                                              }}
                                            >
                                              Delete
                                            </span>
                                          </Button>
                                        </DisabledButtonStyle>
                                      </Menu.Item>
                                    )}
                                    {!switchFetchOrdersfromERP && ((details.state == "approved" &&
                                      details.processQuantity == 0) ||
                                      details.state == "hold" ||
                                      details.state == "pending" ||
                                      details.state == "review" ||
                                      details.state == "rejected") && props.selectedOrder.isEditAllowed && (
                                      <Menu.Item
                                        key="12"
                                        style={{ marginBottom: "-10px" }}
                                      >
                                        <DisabledButtonStyle>
                                          <Button
                                            style={{
                                              border: "none",
                                              background: "none",
                                              padding: "0",
                                              font: "inherit",
                                              textAlign: "left",
                                              width: "100%",
                                            }}
                                            // disabled={(details.state !== "approved")}
                                            onClick={() => handleCancel()}
                                          >
                                            <span
                                              style={{
                                                color: "rgba(0, 0, 0, 0.85)",
                                              }}
                                            >
                                              Cancel Order
                                            </span>
                                          </Button>
                                        </DisabledButtonStyle>
                                      </Menu.Item>
                                    )}
                                    {details.state == "approved" &&
                                      details.pending_quantity && props.selectedOrder.isEditAllowed&& (
                                        <Menu.Item
                                          key="13"
                                          style={{ marginBottom: "-10px" }}
                                        >
                                          <DisabledButtonStyle>
                                            <Button
                                              style={{
                                                border: "none",
                                                background: "none",
                                                padding: "0",
                                                font: "inherit",
                                                textAlign: "left",
                                                width: "100%",
                                              }}
                                              disabled={
                                                details.state !== "approved"
                                              }
                                              onClick={() =>
                                                handleHold(details)
                                              }
                                            >
                                              <span
                                                style={{
                                                  color:
                                                    details.state !== "approved"
                                                      ? "#A19F9D"
                                                      : "rgba(0, 0, 0, 0.85)",
                                                }}
                                              >
                                                Hold Order
                                              </span>
                                            </Button>
                                          </DisabledButtonStyle>
                                        </Menu.Item>
                                      )}
                                    {details.state == "hold" && props.selectedOrder.isEditAllowed&& (
                                      <Menu.Item
                                        key="14"
                                        style={{ marginBottom: "1px" }}
                                      >
                                        <DisabledButtonStyle>
                                          <Button
                                            style={{
                                              border: "none",
                                              background: "none",
                                              padding: "0",
                                              font: "inherit",
                                              textAlign: "left",
                                              width: "100%",
                                            }}
                                            disabled={details.state !== "hold"}
                                            onClick={() => handleRelease()}
                                          >
                                            <span
                                              style={{
                                                color:
                                                  details.state !== "hold"
                                                    ? "#A19F9D"
                                                    : "rgba(0, 0, 0, 0.85)",
                                              }}
                                            >
                                              Release Order
                                            </span>
                                          </Button>
                                        </DisabledButtonStyle>
                                      </Menu.Item>
                                    )}
                                  </Menu>
                                }
                                placement="top"
                                arrow
                              >
                                <Button
                                  style={{
                                    margin: "0px 10px 0px 0px",
                                    padding: "4px 12px",
                                  }}
                                  className="themeBtn noBg active"
                                >
                                  <span style={{ margin: "0px" }}>
                                    More Actions{" "}
                                  </span>
                                </Button>
                              </Dropdown>
                            </Form.Item>
                          ) : (
                            <Form.Item>
                              <Dropdown
                                className="viewDropdownStyle"
                                overlay={
                                  <Menu>
                                    <Menu.Item
                                      key="1"
                                      style={{
                                        marginTop: "-5px",
                                        marginBottom: "-10px",
                                      }}
                                    >
                                      <DisabledButtonStyle>
                                        <Button
                                          onClick={onViewPODetailsHandler}
                                          style={{
                                            border: "none",
                                            background: "none",
                                            color: "inherit",
                                            padding: "0",
                                            font: "inherit",
                                            cursor: "pointer",
                                            outline: "inherit",
                                            textAlign: "left",
                                          }}
                                        >
                                          {props.category==='po'?"View PO Details":"View SO Details"}
                                        </Button>{" "}
                                      </DisabledButtonStyle>
                                    </Menu.Item>
                                    <Menu.Item
                                      key="2"
                                      style={{ marginBottom: "1px" }}
                                    >
                                      <DisabledButtonStyle>
                                        <Button
                                          onClick={onViewChangeHandler}
                                          style={{
                                            border: "none",
                                            background: "none",
                                            color: "inherit",
                                            padding: "0",
                                            font: "inherit",
                                            cursor: "pointer",
                                            outline: "inherit",
                                            textAlign: "left",
                                          }}
                                        >
                                          View Change History
                                        </Button>{" "}
                                      </DisabledButtonStyle>
                                    </Menu.Item>
                                  </Menu>
                                }
                                placement="top"
                                arrow
                              >
                                <Button
                                  style={{
                                    margin: "0px 10px 0px 0px",
                                    padding: "4px 12px",
                                  }}
                                  className="themeBtn noBg active"
                                  // disabled={details.state !== "pending"}
                                >
                                  <span style={{ margin: "0px" }}>
                                    More Actions{" "}
                                  </span>
                                </Button>
                              </Dropdown>
                            </Form.Item>
                          )}
                        </div>
                      )}
                    </div>
                  )}
              </Form>
            </HaberForm>
          </DetailFields>
        </div>
      </RightDrawerContainer>

      <ModalPopup visible={isVisibleApprovalModal.visible}>
        <div className="Popup-img">
          <img src={warning} alt="Warning" />
        </div>
        <div className="Popup-content">
          <span>Send for approval?</span>
          <p>
            You cannot make changes to the orders once the order is approved or
            rejected. Are you sure you want to proceed?
          </p>
        </div>
        <div className="ant-modal-footer-section">
          <Button
            key="back"
            className="themeBtn-plane"
            onClick={() => approvalModalClose()}
          >
            <div className="plusPopUpBorder">
              <Iconmoon
                icon="plus-sign"
                size={9}
                color="#EA655B"
                className="ant-ico-sec"
              />
            </div>
            Cancel
          </Button>
          <Button
            key="submit"
            className="themeBtn"
            onClick={() => approvalModalConfirm(isVisibleApprovalModal?.data)}
          >
            <Iconmoon icon="tick-mark" size={14} color="#ffff" />
            Confirm
          </Button>
        </div>
      </ModalPopup>

      {/* Delete confirmation modal */}
      <ModalPopup visible={isVisibleDeleteModal}>
        <div className="Popup-img">
          <img src={warning} alt="Warning" />
        </div>
        <div className="Popup-content">
          <span>Delete Order?</span>
          <p>
            You will not be able to recover the order if you delete it. Are you
            sure you want to proceed?
          </p>
        </div>
        <div className="ant-modal-footer-section">
          <Button
            key="back"
            className="themeBtn-plane"
            onClick={() => deleteModalClose()}
          >
            <div className="plusPopUpBorder">
              <Iconmoon
                icon="plus-sign"
                size={9}
                color="#EA655B"
                className="ant-ico-sec"
              />
            </div>
            Cancel
          </Button>

          <Button
            key="submit"
            className="themeBtn"
            onClick={() => deleteModalConfirm(props.selectedOrderNo)}
          >
            <Iconmoon icon="tick-mark" size={14} color="#ffff" />
            Confirm
          </Button>
        </div>
      </ModalPopup>

      <ConfirmationModal
        visible={isVisiblePriorityModal}
        icon={warning}
        param={props?.selectedOrder}
        confirmAction={priorityModalConfirm}
        cancelAction={priorityModalClose}
      >
        <span>
          {props?.selectedOrder?.priority
            ? "Remove priority?"
            : "Prioritize Order?"}
        </span>
        <p>
          {props?.selectedOrder?.priority
            ? "The order will be treated as a regular order. Are you sure you want to continue?"
            : "The order will be upgraded to a prioritized order and will be completely matched in deckle. Are you sure you want to proceed?"}
        </p>
      </ConfirmationModal>

      <ConfirmationModal
        visible={isVisibleReleaseModal}
        icon={warning}
        param={props?.selectedOrder}
        confirmAction={releaseModalConfirm}
        cancelAction={releaseModalClose}
      >
        <span> {"Release order for production?"} </span>
        <p>
          {
            "The order will be matched in next deckle. Are you sure you want to proceed?"
          }
        </p>
      </ConfirmationModal>
    </RightDrawerSidebar>
  ) : null;
};
export default MultiDiaEditOrderDrawer;
